import { YLanguage } from '../lib/y/i18n';

export interface I18NSpec {
    aa: {
        b_add: string,
        b_add_pictures: string,
        b_add_recipient: string,
        b_add_session: string,
        b_add_tickets: string,
        b_add_user: string,
        b_booking_list: string,
        b_change: string,
        b_create_event: string,
        b_download: string,
        b_download_pdf: string,
        b_duplicate: string,
        b_edit: string,
        b_import: string,
        b_import_selected: string,
        b_missing_info: string,
        b_save_add_dates: string,
        b_save_send: string,
        b_send_booking_list: string,
        b_session_cancel: string,
        b_update: string,
        c_amount: string,
        c_booked: string,
        c_booking_number: string,
        c_date: string,
        c_event: string,
        c_event_name: string,
        c_next_date: string,
        c_payment_amount: string,
        c_period: string,
        c_review: string,
        c_standby: string,
        c_status: string,
        c_ticket_amount: string,
        c_tickets: string,
        c_tickets_available: string,
        c_total: string,
        c_user_name: string,
        f_address: string,
        f_choose_venue: string,
        f_city: string,
        f_company_name: string,
        f_date_time: string,
        f_description: string,
        f_dont_feature: string,
        f_dont_feature_sub: string,
        f_dont_market: string,
        f_dont_market_sub: string,
        f_dropin: string,
        f_duration: string,
        f_email: string,
        f_end_time: string,
        f_event_name: string,
        f_genre: string,
        f_i_instructions: string,
        f_i_regular_price: string,
        f_i_sales_end: string,
        f_i_sales_end_sub: string,
        f_instructions: string,
        f_list_recipients: string,
        f_media_links: string,
        f_org_number: string,
        f_payout_destination: string,
        f_permissions: string,
        f_pictures: string,
        f_producer: string,
        f_regular_price: string,
        f_sales_end: string,
        f_ticket_amount: string,
        f_tickets_per_session: string,
        f_venue: string,
        h_add_team: string,
        h_available_sessions: string,
        m_account: string,
        m_handle_events: string,
        m_imported: string,
        m_logout: string,
        m_reviews: string,
        m_sales: string,
        m_summaries: string,
        m_team: string,
        m_upcoming_bookings: string,
        n_bookings: string,
        n_new_event: string,
        n_session: string,
        o_active: string,
        o_all_events: string,
        o_bookings: string,
        o_events: string,
        o_invoices: string,
        o_past: string,
        o_reviews: string,
        o_tickets: string,
        o_tickets_sold: string,
        o_total_sales: string,
        o_users: string,
        tb_company_info: string,
        tb_date_time: string,
        tb_default_info: string,
        tb_event_description: string,
        tb_user_info: string,
        tt_add_amount: string,
        tt_create_event: string,
        tt_edit: string,
        tt_missing_info: string,
        tt_publish_pending: string,
        tt_session_booked: string,
        v_paid_on: string,
        v_started: string,
        w_cancel_booked: string,
        w_missing_info: string,
        w_publish_date: string,
        w_session_booked: string,
        w_session_booked_new: string,
        w_session_booked_previous: string,
    },
    pr: {
        account_account_number: string,
        account_event_defaults: string,
        account_invoice_details: string,
        account_mobile_title: string,
        account_my_details: string,
        account_payment_details: string,
        account_payment_details_description: string,
        account_title: string,
        add_tickets_apply: string,
        add_tickets_current_amount: string,
        add_tickets_placeholder: string,
        add_tickets_title: string,
        booking_list_mobile_title: string,
        booking_list_search: string,
        booking_list_send_tickets: string,
        booking_list_title: string,
        dashboard_earnings: string,
        dashboard_last_payment: string,
        dashboard_none: string,
        dashboard_tickets_booked: string,
        dashboard_total: string,
        error_invalid_media_link: string,
        event_add_link: string,
        event_add_media_link: string,
        event_booking_list: string,
        event_bookings_ticket: string,
        event_bookings_unknown_seat: string,
        event_cancel: string,
        event_copy_url: string,
        event_create: string,
        event_create_new_session: string,
        event_duplicate: string,
        event_edit: string,
        event_email_external: string,
        event_email_team: string,
        event_genre: string,
        event_genre_add: string,
        event_link_copied: string,
        event_photo_credits: string,
        event_save: string,
        event_send_for_review: string,
        event_show: string,
        events_add_sessions: string,
        events_add_tickets: string,
        events_mobile_title: string,
        events_more: string,
        events_status_draft: string,
        events_status_imported: string,
        events_status_live: string,
        events_status_past: string,
        events_status_sent: string,
        events_title: string,
        events_tooltip_amount_managed: string,
        filter_cities_all: string,
        filter_city: string,
        filter_date: string,
        filter_event: string,
        filter_event_imported: string,
        filter_event_live: string,
        filter_event_previous: string,
        filter_event_unpublished: string,
        filter_events: string,
        filter_events_all: string,
        filter_filter: string,
        filter_name: string,
        filter_search: string,
        filter_sort: string,
        filter_time_period: string,
        filter_venue: string,
        filter_venues_all: string,
        filter_year: string,
        filter_year_all: string,
        menu_account: string,
        menu_dashboard: string,
        menu_events: string,
        menu_integration: string,
        menu_logged_in_as: string,
        menu_new_event: string,
        menu_payments: string,
        menu_reviews: string,
        menu_statistics: string,
        menu_team: string,
        menu_upcoming: string,
        payments_mobile_title: string,
        payments_paid: string,
        payments_pending: string,
        payments_tickets: string,
        payments_title: string,
        reviews_download: string,
        reviews_mobile_title: string,
        reviews_search: string,
        reviews_send: string,
        reviews_summary: string,
        reviews_title: string,
        session_booking_stop: string,
        session_create: string,
        session_date: string,
        session_edit_instructions: string,
        session_ticket_type: string,
        session_time: string,
        session_update: string,
        sessions_bookings: string,
        sessions_col_bookings: string,
        sessions_col_closes_at: string,
        sessions_col_date_time: string,
        sessions_col_event: string,
        sessions_col_standby: string,
        sessions_col_ticket_type: string,
        sessions_col_venue: string,
        sessions_mobile_title: string,
        sessions_more_tickets: string,
        sessions_open_until: string,
        sessions_search: string,
        sessions_standby: string,
        sessions_title: string,
        sessions_tooltip_eticket: string,
        sessions_tooltip_guestlist: string,
        team_add_member: string,
        team_admin: string,
        team_admin_description: string,
        team_bookings: string,
        team_bookings_description: string,
        team_economy: string,
        team_economy_description: string,
        team_email_address: string,
        team_events: string,
        team_events_description: string,
        team_invite: string,
        team_invited_users: string,
        team_limited_access: string,
        team_mobile_title: string,
        team_remove_confirm: string,
        team_send_invite: string,
        team_title: string,
        team_update_permissions: string,
        ticket_eticket: string,
        ticket_guestlist: string,
    },
    tl: {
        o_filter_dates: {
            range: string,
            today: string,
            tomorrow: string,
            week: string,
            weekend: string,
        },
        o_gender: {
            female: string,
            male: string,
            other: string,
        },
        o_giftcard_delivery: {
            digital: string,
            post: string,
        },
        td_payment_addons: {
            bonus: string,
            late_cancel: string,
        },
        about_us: string,
        b_accept: string,
        b_add_standby: string,
        b_add_ticket: string,
        b_all_events: string,
        b_ap_login: string,
        b_apply_code: string,
        b_back: string,
        b_back_to_events: string,
        b_book: string,
        b_booked: string,
        b_buy_more: string,
        b_cancel: string,
        b_change_payment: string,
        b_change_plan: string,
        b_change_pw: string,
        b_choose: string,
        b_choose_kind: string,
        b_close: string,
        b_confirm: string,
        b_confirm_booking: string,
        b_continue: string,
        b_copy_code: string,
        b_copy_link: string,
        b_decline: string,
        b_done: string,
        b_enter_gc: string,
        b_extend_pause: string,
        b_fb_connect: string,
        b_fb_continue: string,
        b_fb_login: string,
        b_fill_later: string,
        b_filter_clear: string,
        b_filter_show: string,
        b_forgot: string,
        b_giftcard_confirm_info: string,
        b_giftcard_redeem: string,
        b_have_code: string,
        b_how_it_works: string,
        b_invite_dialog_send: string,
        b_invite_friends_here: string,
        b_invited_resend: string,
        b_leave_comment: string,
        b_lets_go: string,
        b_login: string,
        b_login_email: string,
        b_login_email_instead: string,
        b_login_phone: string,
        b_loyalty_info: string,
        b_membership_choose: string,
        b_membership_resume: string,
        b_more_dates: string,
        b_next: string,
        b_not_member: string,
        b_not_now: string,
        b_ok: string,
        b_pause: string,
        b_pay: string,
        b_pay_autogiro: string,
        b_pay_autogiro_once: string,
        b_pay_card: string,
        b_payment_receipt: string,
        b_read_more: string,
        b_read_more_abundo: string,
        b_renew_subscription: string,
        b_resend_code: string,
        b_reserve: string,
        b_reset_pw: string,
        b_resubscribe_change: string,
        b_resume_now: string,
        b_save: string,
        b_see_all: string,
        b_see_booking: string,
        b_see_event: string,
        b_send: string,
        b_send_invites: string,
        b_share: string,
        b_show_tickets: string,
        b_signup_phone: string,
        b_skip: string,
        b_standby: string,
        b_standby_remove: string,
        b_start_for: string,
        b_start_watching: string,
        b_ticket_pdf: string,
        b_to_my_bookings: string,
        b_try_again: string,
        b_try_month: string,
        b_unbook: string,
        b_unbook_one: string,
        b_undo_cancel: string,
        b_unsubscribe: string,
        b_video_account: string,
        b_video_buy_amount: string,
        b_video_remind: string,
        b_voucher: string,
        become_member: string,
        bnr_cancelled: string,
        bnr_cancelled_b: string,
        bnr_none: string,
        bnr_none_b: string,
        bnr_pastdue: string,
        bnr_pastdue_b: string,
        bnr_paused: string,
        bnr_paused_b: string,
        bnr_pending_cancel: string,
        bnr_pending_cancel_b: string,
        booking_starts: string,
        cb_notifications_event_info: string,
        cb_notifications_standby: string,
        cb_profile_show_activity: string,
        consent_accept: string,
        consent_link: string,
        consent_preferences: string,
        consent_text: string,
        consent_title: string,
        e_bookings: string,
        e_invalid_code: string,
        events: string,
        faq: string,
        for_companies: string,
        giftcard_b2b: string,
        h_booking: string,
        h_booking_confirmation: string,
        h_bookings: string,
        h_bookings_current: string,
        h_bookings_past: string,
        h_bookings_standby: string,
        h_cancel_dialog: string,
        h_card_details: string,
        h_change_plan_dialog: string,
        h_choose_membership: string,
        h_city: string,
        h_create_account: string,
        h_extend_pause: string,
        h_filter: string,
        h_filter_category: string,
        h_filter_city: string,
        h_filter_date: string,
        h_filter_sort: string,
        h_forgot: string,
        h_friends: string,
        h_giftcard_contact: string,
        h_giftcard_delivery: string,
        h_giftcard_delivery_address: string,
        h_giftcard_kind: string,
        h_giftcard_kind_2: string,
        h_giftcard_months: string,
        h_giftcard_quantity: string,
        h_instructions: string,
        h_invite_dialog: string,
        h_invite_email: string,
        h_invite_link: string,
        h_invite_popup_1: string,
        h_invite_popup_2: string,
        h_invite_popup_3: string,
        h_invite_reward: string,
        h_invited: string,
        h_language: string,
        h_login: string,
        h_membership: string,
        h_membership_have_gc: string,
        h_no_commitment: string,
        h_onboarding: string,
        h_onboarding_category: string,
        h_onboarding_city: string,
        h_onboarding_phone: string,
        h_past: string,
        h_pause_dialog: string,
        h_payment: string,
        h_payment_history: string,
        h_profile: string,
        h_profile_favorites: string,
        h_profile_pw: string,
        h_redeem_gc: string,
        h_referral_popup: string,
        h_reserve_dialog: string,
        h_reset_pw: string,
        h_resubscribe_dialog: string,
        h_reviews: string,
        h_search: string,
        h_signup: string,
        h_signup_confirm_info: string,
        h_signup_with_email: string,
        h_standby_first: string,
        h_thanks: string,
        h_video_not_active: string,
        h_voucher: string,
        how_it_works: string,
        invite: string,
        jobs: string,
        l_my_account: string,
        l_read_more_here: string,
        m_bookings: string,
        m_friends: string,
        m_giftcard: string,
        m_help_center: string,
        m_home: string,
        m_login: string,
        m_logout: string,
        m_membership: string,
        m_profile: string,
        m_purchases: string,
        m_signup: string,
        more_dates: string,
        o_filter_sort_date: string,
        o_filter_sort_recommended: string,
        o_past_3: string,
        o_past_all: string,
        o_tag_all: string,
        p_loyalty: string,
        p_payment_history_bonus: string,
        partners: string,
        past: string,
        ph_address: string,
        ph_birth_year: string,
        ph_city: string,
        ph_company_name: string,
        ph_current_pw: string,
        ph_email: string,
        ph_first_name: string,
        ph_gc_amount: string,
        ph_gc_code: string,
        ph_invite_emails: string,
        ph_last_name: string,
        ph_name: string,
        ph_new_pw: string,
        ph_password: string,
        ph_phone: string,
        ph_postcity: string,
        ph_postcode: string,
        ph_search: string,
        ph_venue: string,
        ph_voucher_code: string,
        play: string,
        press: string,
        privacy: string,
        q_onboarding_1: string,
        q_onboarding_2: string,
        q_onboarding_3: string,
        q_onboarding_3m: string,
        resubscribe_popup_button: string,
        resubscribe_popup_text: string,
        resubscribe_popup_title: string,
        s_reservation_declined: string,
        several_dates: string,
        standby_open_until: string,
        t_1_ticket: string,
        t_book_1_extra_ticket: string,
        t_book_accept: string,
        t_book_conditions: string,
        t_book_extra_tickets: string,
        t_book_free_unbook: string,
        t_book_no_free_unbook: string,
        t_book_read_more: string,
        t_booking_accept: string,
        t_booking_amount_1: string,
        t_booking_amount_n: string,
        t_booking_confirmation: string,
        t_booking_instructions: string,
        t_booking_number: string,
        t_booking_tos: string,
        t_cancel_dialog_1: string,
        t_cancel_dialog_2: string,
        t_cancel_dialog_comment: string,
        t_cancel_dialog_pause: string,
        t_cancel_dialog_unbook: string,
        t_card_details_why: string,
        t_changeplan_downgrade_1: string,
        t_changeplan_downgrade_2: string,
        t_changeplan_downgrade_3: string,
        t_changeplan_event_1: string,
        t_changeplan_event_2: string,
        t_changeplan_event_3: string,
        t_changeplan_total: string,
        t_changeplan_upgrade_1: string,
        t_changeplan_upgrade_2: string,
        t_changeplan_upgrade_3: string,
        t_choose_membership: string,
        t_decline_confirmation: string,
        t_event_duration_h: string,
        t_event_duration_m: string,
        t_fb_connect: string,
        t_forgot_sent: string,
        t_forgot_spam: string,
        t_giftcard_delivery_email: string,
        t_giftcard_delivery_post: string,
        t_giftcard_discount: string,
        t_giftcard_payment: string,
        t_have_reservation: string,
        t_invite_choose_from: string,
        t_invite_code: string,
        t_invite_code_info: string,
        t_invite_dialog_choose: string,
        t_invite_email: string,
        t_invite_or: string,
        t_invite_popup_1: string,
        t_invite_popup_2: string,
        t_invite_popup_3: string,
        t_invited_saved: string,
        t_membership_cancelled: string,
        t_membership_gc: string,
        t_membership_next_billing: string,
        t_membership_none: string,
        t_membership_pastdue: string,
        t_membership_paused: string,
        t_membership_pauses: string,
        t_more_events_bottom: string,
        t_more_events_count: string,
        t_n_tickets: string,
        t_newsletter_thanks_city: string,
        t_onboarding: string,
        t_onboarding_category: string,
        t_onboarding_city: string,
        t_onboarding_phone_1: string,
        t_onboarding_phone_2: string,
        t_past: string,
        t_past_archived_1: string,
        t_past_archived_2: string,
        t_past_archived_3: string,
        t_pastdue_unbook_warning: string,
        t_pause_choose_months: string,
        t_pause_dialog: string,
        t_pause_dialog_unsubscribe: string,
        t_ppv_confirmation_1: string,
        t_ppv_confirmation_2: string,
        t_ppv_confirmation_3: string,
        t_profile_favorites: string,
        t_profile_name: string,
        t_profile_show_activity: string,
        t_promo_code: string,
        t_rate_event: string,
        t_referral_popup_1: string,
        t_referral_popup_2: string,
        t_referral_popup_3: string,
        t_reserve_dialog: string,
        t_reset_pw: string,
        t_resubscribe_dialog: string,
        t_review_see_more: string,
        t_reviews: string,
        t_signup_accept: string,
        t_signup_already: string,
        t_signup_ask_city: string,
        t_signup_ask_email: string,
        t_signup_ask_name: string,
        t_signup_confirm_email: string,
        t_signup_confirm_name: string,
        t_signup_dont_activate_text: string,
        t_signup_email_already: string,
        t_signup_email_password: string,
        t_signup_enter_email_code: string,
        t_signup_enter_phone: string,
        t_signup_enter_phone_code: string,
        t_signup_gender_age: string,
        t_signup_name_why: string,
        t_signup_or: string,
        t_signup_phone_verified: string,
        t_signup_privacy: string,
        t_signup_select_city: string,
        t_signup_select_subscription: string,
        t_signup_subscription_explain: string,
        t_signup_terms: string,
        t_signup_verify_phone: string,
        t_ticket_activates: string,
        t_ticket_booking: string,
        t_ticket_guestlist: string,
        t_ticket_nonrefundable: string,
        t_ticket_people: string,
        t_ticket_person: string,
        t_ticket_personal: string,
        t_ticket_row: string,
        t_ticket_seat: string,
        t_video_live_members: string,
        t_video_live_now: string,
        t_video_not_active: string,
        t_video_not_available: string,
        t_video_remind_confirmation: string,
        t_video_reminder: string,
        t_video_replay: string,
        t_video_starts: string,
        t_video_until: string,
        td_invite_accepted: string,
        td_invite_sent: string,
        td_payment_failed: string,
        td_payment_giftcard: string,
        td_payment_membership: string,
        td_payment_purchase: string,
        td_payment_refund: string,
        td_payment_tickets: string,
        td_payment_upgrade: string,
        td_payment_valid_until: string,
        terms: string,
        th_payment_date: string,
        th_payment_description: string,
        th_payment_method: string,
        th_payment_total: string,
        tt_accept_latest: string,
        tt_book_before: string,
        w_cantbook_already: string,
        w_cantbook_been: string,
        w_cantbook_cancel: string,
        w_cantbook_ended: string,
        w_cantbook_expired: string,
        w_cantbook_gc: string,
        w_cantbook_limit: string,
        w_cantbook_loyalty: string,
        w_cantbook_loyalty_inactive: string,
        w_cantbook_notickets: string,
        w_cantbook_pastdue: string,
        w_cantbook_paused: string,
        w_cantbook_sameday: string,
        w_dismiss_rating: string,
        w_late_unbook: string,
        w_membership_recovered: string,
        w_standby: string,
        w_standby_1: string,
        w_standby_2: string,
        w_standby_first: string,
        w_standby_info: string,
        w_unbook: string,
        w_unbook_one: string,
    },
    ui: {
        back_to: string,
        button_cancel: string,
        button_delete: string,
        button_no: string,
        button_ok: string,
        button_save: string,
        button_send: string,
        button_yes: string,
        img_drop: string,
        inv_email: string,
        inv_number: string,
        inv_password: string,
        inv_required: string,
        select_dates: string,
    },
    y: {
        currency_format: {
            EUR: string,
            SEK: string,
        },
        days: string[],
        months: string[],
        short_days: string[],
        short_months: string[],
    },
}

export const $i18n_specs: {[language in YLanguage]?: I18NSpec} = {};

$i18n_specs['en'] = {
    aa: {
        b_add: "Add",
        b_add_pictures: "+ Add more pictures",
        b_add_recipient: "+ Add more recipients",
        b_add_session: "+ Add session",
        b_add_tickets: "ADD TICKETS",
        b_add_user: "ADD USER",
        b_booking_list: "BOOKING LIST",
        b_change: "CHANGE",
        b_create_event: "CREATE NEW EVENT",
        b_download: "Download",
        b_download_pdf: "Download as PDF",
        b_duplicate: "DUPLICATE",
        b_edit: "EDIT",
        b_import: "Import",
        b_import_selected: "Import selected sessions",
        b_missing_info: "Fill in the details here.",
        b_save_add_dates: "Save and add dates",
        b_save_send: "Save and send for approval",
        b_send_booking_list: "Send booking list to",
        b_session_cancel: "REMOVE",
        b_update: "Update",
        c_amount: "Amount",
        c_booked: "booked",
        c_booking_number: "Booking number",
        c_date: "Date",
        c_event: "Event",
        c_event_name: "Name",
        c_next_date: "Next date",
        c_payment_amount: "Amount",
        c_period: "Period",
        c_review: "Review",
        c_standby: "on standby",
        c_status: "Status",
        c_ticket_amount: "Number of tickets",
        c_tickets: "Tickets",
        c_tickets_available: "$1$ tickets available",
        c_total: "Total",
        c_user_name: "Name",
        f_address: "Address",
        f_choose_venue: "Choose venue",
        f_city: "City",
        f_company_name: "Company name",
        f_date_time: "Time \u0026 Date",
        f_description: "Describe your event",
        f_dont_feature: "Do not feature this event on the public Abundo website",
        f_dont_feature_sub: "We will only show your event to logged in users",
        f_dont_market: "Do not market this event outside of the Abundo platform",
        f_dont_market_sub: "We will not share your event on our social media channels",
        f_dropin: "Drop-in session",
        f_duration: "Set event length (minutes)",
        f_email: "E-mail address",
        f_end_time: "To",
        f_event_name: "Name your event",
        f_genre: "Genre",
        f_i_instructions: "Describe ticket collection instructions",
        f_i_regular_price: "Enter the events regular ticket price",
        f_i_sales_end: "Set booking stop (hours before the event starts)",
        f_i_sales_end_sub: "We recommend 2 hours before the event starts.",
        f_instructions: "Ticket collection instruction",
        f_list_recipients: "Guest list recipient",
        f_media_links: "Add media links",
        f_org_number: "Organization Number",
        f_payout_destination: "Account for payout",
        f_permissions: "Permissions",
        f_pictures: "Pictures",
        f_producer: "Producer",
        f_regular_price: "Regular ticket price",
        f_sales_end: "Booking stop (hours before starting)",
        f_ticket_amount: "Number of tickets",
        f_tickets_per_session: "Tickets per session",
        f_venue: "Venue",
        h_add_team: "Add a user to your team",
        h_available_sessions: "AVAILABLE SESSIONS",
        m_account: "Account",
        m_handle_events: "Manage events",
        m_imported: "Imported",
        m_logout: "Logout",
        m_reviews: "Reviews",
        m_sales: "Sales",
        m_summaries: "Summaries",
        m_team: "Team",
        m_upcoming_bookings: "Upcoming bookings",
        n_bookings: "BOOKINGS",
        n_new_event: "NEW EVENT",
        n_session: "SESSION",
        o_active: "LIVE",
        o_all_events: "All events",
        o_bookings: "bookings",
        o_events: "events",
        o_invoices: "invoices",
        o_past: "EARLIER",
        o_reviews: "reviews",
        o_tickets: "tickets",
        o_tickets_sold: "tickets sold",
        o_total_sales: "total sales",
        o_users: "users",
        tb_company_info: "Company information",
        tb_date_time: "Date \u0026 Time",
        tb_default_info: "Standard info",
        tb_event_description: "Event description",
        tb_user_info: "My information",
        tt_add_amount: "Number of subscribers that would like to book if you add more tickets.",
        tt_create_event: "Create event",
        tt_edit: "Edit",
        tt_missing_info: "The event is missing information",
        tt_publish_pending: "Waiting for publication",
        tt_session_booked: "$1$ booked + $2$ reserved",
        v_paid_on: "Paid $1$",
        v_started: "Started",
        w_cancel_booked: "There are bookings for this show. If you remove it the people who have booked will be automatically informed. Are you sure you wish to remove the showing?",
        w_missing_info: "We are missing important company details.",
        w_publish_date: "This date will be published $1$",
        w_session_booked: "There are bookings for this scheduled playing time. The people who have booked this show will automatically be notified if you change the If you change the scheduled playing time. Are you sure you want to change the scheduled playing time to the following?",
        w_session_booked_new: "New time: $1$",
        w_session_booked_previous: "Earlier time: $1$",
    },
    pr: {
        account_account_number: "Account number",
        account_event_defaults: "Event defaults",
        account_invoice_details: "Invoice details",
        account_mobile_title: "Settings",
        account_my_details: "My details",
        account_payment_details: "Invoice details",
        account_payment_details_description: "Where should we submit your payments?",
        account_title: "Settings",
        add_tickets_apply: "Apply change",
        add_tickets_current_amount: "Current amount: $1$ tickets",
        add_tickets_placeholder: "Set new ticket amount",
        add_tickets_title: "Add tickets to session",
        booking_list_mobile_title: "Booking list",
        booking_list_search: "Search",
        booking_list_send_tickets: "When booking is closed you send the booked amount to $1$",
        booking_list_title: "Booking list",
        dashboard_earnings: "Payouts",
        dashboard_last_payment: "Last payout",
        dashboard_none: "None",
        dashboard_tickets_booked: "Tickets booked",
        dashboard_total: "Total",
        error_invalid_media_link: "Invalid media link",
        event_add_link: "Add link",
        event_add_media_link: "Add media link",
        event_booking_list: "Booking list",
        event_bookings_ticket: "Ticket $1$",
        event_bookings_unknown_seat: "Unknown seat",
        event_cancel: "Cancel event",
        event_copy_url: "Copy URL",
        event_create: "Create event",
        event_create_new_session: "Create new session",
        event_duplicate: "Duplicate event",
        event_edit: "Edit event",
        event_email_external: "Or submit external email address",
        event_email_team: "Choose team member",
        event_genre: "Enter genre",
        event_genre_add: "+ Add another genre",
        event_link_copied: "Link copied to clipboard",
        event_photo_credits: "Photo credits",
        event_save: "Save",
        event_send_for_review: "Send for review",
        event_show: "Show event",
        events_add_sessions: "Add sessions",
        events_add_tickets: "Add tickets",
        events_mobile_title: "Events",
        events_more: "+$1$ more",
        events_status_draft: "Draft",
        events_status_imported: "Imported",
        events_status_live: "Live",
        events_status_past: "Past",
        events_status_sent: "Review pending",
        events_title: "Edit events",
        events_tooltip_amount_managed: "Managed through your regular ticketing system",
        filter_cities_all: "All cities",
        filter_city: "City",
        filter_date: "Date",
        filter_event: "Event",
        filter_event_imported: "Imported",
        filter_event_live: "Live",
        filter_event_previous: "Previous",
        filter_event_unpublished: "Unpublished",
        filter_events: "Events",
        filter_events_all: "All events",
        filter_filter: "Filter",
        filter_name: "Name",
        filter_search: "Search",
        filter_sort: "Sort",
        filter_time_period: "Time period",
        filter_venue: "Venue",
        filter_venues_all: "All venues",
        filter_year: "Year",
        filter_year_all: "All years",
        menu_account: "Settings",
        menu_dashboard: "Dashboard",
        menu_events: "Events",
        menu_integration: "Integration",
        menu_logged_in_as: "Logged in as",
        menu_new_event: "New event",
        menu_payments: "Payments",
        menu_reviews: "Reviews",
        menu_statistics: "Statistics",
        menu_team: "Team",
        menu_upcoming: "Bookings",
        payments_mobile_title: "Payouts: $1$",
        payments_paid: "Paid $1$",
        payments_pending: "Payout pending",
        payments_tickets: "$1$ tickets",
        payments_title: "Total payouts: $1$",
        reviews_download: "Download as PDF",
        reviews_mobile_title: "Reviews",
        reviews_search: "Search events",
        reviews_send: "Send",
        reviews_summary: "Summary",
        reviews_title: "Reviews: All events",
        session_booking_stop: "Set booking stop",
        session_create: "Create session",
        session_date: "Date",
        session_edit_instructions: "Edit instructions",
        session_ticket_type: "Ticket type",
        session_time: "Time",
        session_update: "Update session",
        sessions_bookings: "$1$ booked",
        sessions_col_bookings: "Bookings",
        sessions_col_closes_at: "Closes at",
        sessions_col_date_time: "Date and time",
        sessions_col_event: "Event",
        sessions_col_standby: "Standby",
        sessions_col_ticket_type: "Method",
        sessions_col_venue: "Venue",
        sessions_mobile_title: "Bookings",
        sessions_more_tickets: "Add tickets",
        sessions_open_until: "Open until $1$",
        sessions_search: "Search sessions",
        sessions_standby: "$1$ standby",
        sessions_title: "Bookings for upcoming sessions",
        sessions_tooltip_eticket: "When booking closes at $1$, send the total booked amount in one order from your ticketing system to:\nSweden: tickets@abundolive.se\nGermany: tickets@abundolive.de",
        sessions_tooltip_guestlist: "When booking closes at $1$, a digital guest list and PDF are sent to $2$.",
        team_add_member: "Add user",
        team_admin: "Admin",
        team_admin_description: "Full access and can add and remove users",
        team_bookings: "Bookings",
        team_bookings_description: "View Bookings",
        team_economy: "Payouts",
        team_economy_description: "View payouts and invoices",
        team_email_address: "Email address",
        team_events: "Events",
        team_events_description: "View, create and edit events",
        team_invite: "Invite user",
        team_invited_users: "Invited users",
        team_limited_access: "Limited access",
        team_mobile_title: "$1$ team",
        team_remove_confirm: "Are you sure you want to remove this user?",
        team_send_invite: "Send invite",
        team_title: "$1$ team",
        team_update_permissions: "Update permissions",
        ticket_eticket: "E-ticket",
        ticket_guestlist: "Guestlist",
    },
    tl: {
        o_filter_dates: {
            range: "Date range",
            today: "Today",
            tomorrow: "Tomorrow",
            week: "This week",
            weekend: "This weekend",
        },
        o_gender: {
            female: "Female",
            male: "Male",
            other: "Other",
        },
        o_giftcard_delivery: {
            digital: "Email",
            post: "Mail",
        },
        td_payment_addons: {
            bonus: "Bonus",
            late_cancel: "Cancelation Fee",
        },
        about_us: "About us",
        b_accept: "Accept",
        b_add_standby: "Add standby ticket",
        b_add_ticket: "Add ticket",
        b_all_events: "See all events",
        b_ap_login: "Log in with Apple",
        b_apply_code: "Apply code",
        b_back: "Back",
        b_back_to_events: "Back to all events",
        b_book: "Book",
        b_booked: "Booked",
        b_buy_more: "Buy more tickets",
        b_cancel: "Cancel",
        b_change_payment: "Change payment method",
        b_change_plan: "Change membership",
        b_change_pw: "Change password",
        b_choose: "Choose",
        b_choose_kind: "Select",
        b_close: "Close",
        b_confirm: "Confirm",
        b_confirm_booking: "Confirm booking",
        b_continue: "Continue",
        b_copy_code: "Copy code",
        b_copy_link: "Copy link",
        b_decline: "Decline",
        b_done: "Done",
        b_enter_gc: "Enter the code",
        b_extend_pause: "Extend pause",
        b_fb_connect: "Connect to Facebook",
        b_fb_continue: "Continue with Facebook",
        b_fb_login: "Log in with Facebook",
        b_fill_later: "Answer later",
        b_filter_clear: "Clear filter",
        b_filter_show: "Show results",
        b_forgot: "Forgot password?",
        b_giftcard_confirm_info: "Confirm details",
        b_giftcard_redeem: "Redeem gift card",
        b_have_code: "Do you have a code?",
        b_how_it_works: "How it works",
        b_invite_dialog_send: "Send invites",
        b_invite_friends_here: "Invite friends here.",
        b_invited_resend: "Send again",
        b_leave_comment: "Do you want to leave a comment?",
        b_lets_go: "Go!",
        b_login: "Log in",
        b_login_email: "Log in with email",
        b_login_email_instead: "Log in via email instead",
        b_login_phone: "Log in with phone number",
        b_loyalty_info: "Info",
        b_membership_choose: "Select subscription",
        b_membership_resume: "Resume membership",
        b_more_dates: "Show more dates",
        b_next: "Next",
        b_not_member: "Not a member? Sign up here",
        b_not_now: "Not now",
        b_ok: "OK",
        b_pause: "Pause",
        b_pay: "Pay $2$ $1$",
        b_pay_autogiro: "Autogiro",
        b_pay_autogiro_once: "Direct Bank Transfer with Trustly",
        b_pay_card: "Card",
        b_payment_receipt: "Receipt",
        b_read_more: "Read more",
        b_read_more_abundo: "Read more about Abundo",
        b_renew_subscription: "Extend membership",
        b_resend_code: "Resend code",
        b_reserve: "Reserve",
        b_reset_pw: "Reset password",
        b_resubscribe_change: "Change payment method or membership",
        b_resume_now: "Resume now",
        b_save: "Save",
        b_see_all: "See all",
        b_see_booking: "See my booking",
        b_see_event: "See event",
        b_send: "Send",
        b_send_invites: "Send invites",
        b_share: "Share",
        b_show_tickets: "Show tickets",
        b_signup_phone: "Sign up with phone number",
        b_skip: "Skip",
        b_standby: "Standby",
        b_standby_remove: "Remove yourself from the list",
        b_start_for: "Start for",
        b_start_watching: "Start watching",
        b_ticket_pdf: "Open PDF ticket",
        b_to_my_bookings: "See my bookings",
        b_try_again: "Try again",
        b_try_month: "Try a free month",
        b_unbook: "Unbook",
        b_unbook_one: "Cancel one ticket",
        b_undo_cancel: "Undo cancellation",
        b_unsubscribe: "Unsubscribe",
        b_video_account: "My account",
        b_video_buy_amount: "Buy access for SEK $1$",
        b_video_remind: "Remind me",
        b_voucher: "Voucher?",
        become_member: "Become a member",
        bnr_cancelled: "Your membership is canceled.",
        bnr_cancelled_b: "Resume membership.",
        bnr_none: "You have no active membership.",
        bnr_none_b: "Choose membership.",
        bnr_pastdue: "We were unable to make a payment.",
        bnr_pastdue_b: "Update payment.",
        bnr_paused: "Your membership is suspended.",
        bnr_paused_b: "Resume your membership.",
        bnr_pending_cancel: "Your membership will be canceled.",
        bnr_pending_cancel_b: "Undo cancellation.",
        booking_starts: "Starts",
        cb_notifications_event_info: "Important information about your bookings",
        cb_notifications_standby: "Standby reservations",
        cb_profile_show_activity: "Show what I'm going to",
        consent_accept: "Accept all cookies",
        consent_link: "Cookie Policy",
        consent_preferences: "Cookie settings",
        consent_text: "We use cookies and similar technologies to personalize content, tailor and measure ads and provide a better experience. By clicking Accept all cookies or turning on an option in Cookie Settings, you agree to this as set out in our $1$. To change your preferences or withdraw your consent, please update your Cookie Settings.",
        consent_title: "Your privacy",
        e_bookings: "You have no bookings.",
        e_invalid_code: "Invalid code",
        events: "Events",
        faq: "FAQ",
        for_companies: "For Companies",
        giftcard_b2b: "Gift cards for businesses",
        h_booking: "Your tickets",
        h_booking_confirmation: "Booking confirmed",
        h_bookings: "My bookings",
        h_bookings_current: "CURRENT",
        h_bookings_past: "PREVIOUS",
        h_bookings_standby: "STANDBY",
        h_cancel_dialog: "Cancel membership",
        h_card_details: "Card details",
        h_change_plan_dialog: "Important information",
        h_choose_membership: "Select subscription",
        h_city: "City",
        h_create_account: "Create account",
        h_extend_pause: "Extend pause",
        h_filter: "Filter",
        h_filter_category: "Category",
        h_filter_city: "City",
        h_filter_date: "Date",
        h_filter_sort: "Sort by",
        h_forgot: "Forgot password?",
        h_friends: "Friends",
        h_giftcard_contact: "Your contact details",
        h_giftcard_delivery: "4. Choose delivery method",
        h_giftcard_delivery_address: "Delivery address",
        h_giftcard_kind: "3. Select subscription",
        h_giftcard_kind_2: "2. Select subscription",
        h_giftcard_months: "1. Choose number of months",
        h_giftcard_quantity: "2. Select the number of gift cards",
        h_instructions: "Instructions",
        h_invite_dialog: "Invite contacts",
        h_invite_email: "Invite by email",
        h_invite_link: "Invite by link",
        h_invite_popup_1: "Share your link",
        h_invite_popup_2: "Your friend gets one month free",
        h_invite_popup_3: "You get $1$",
        h_invite_reward: "You get $1$ every time you invite a friend to a free month!",
        h_invited: "Invited friends",
        h_language: "Language",
        h_login: "Log in",
        h_membership: "Membership",
        h_membership_have_gc: "Do you have a gift card?",
        h_no_commitment: "No commitment, cancel whenever you want",
        h_onboarding: "We'd like to get to know you better",
        h_onboarding_category: "Your favorites",
        h_onboarding_city: "Your city",
        h_onboarding_phone: "Your phone number?",
        h_past: "Past events",
        h_pause_dialog: "Pause your subscription?",
        h_payment: "Payment",
        h_payment_history: "Payment history",
        h_profile: "My personal details",
        h_profile_favorites: "My favorites",
        h_profile_pw: "Change password",
        h_redeem_gc: "Enter the code found on the gift card",
        h_referral_popup: "Invite from",
        h_reserve_dialog: "Reserve",
        h_reset_pw: "Reset password",
        h_resubscribe_dialog: "Resume membership",
        h_reviews: "Reviews",
        h_search: "Search results for",
        h_signup: "Create account",
        h_signup_confirm_info: "Confirm your information",
        h_signup_with_email: "Register with your email address",
        h_standby_first: "Standby",
        h_thanks: "Thank you!",
        h_video_not_active: "Your account is not active",
        h_voucher: "Voucher",
        how_it_works: "How Abundo works",
        invite: "Invite friends",
        jobs: "Work with us",
        l_my_account: "My account",
        l_read_more_here: "Read more",
        m_bookings: "My bookings",
        m_friends: "Friends",
        m_giftcard: "Gift cards",
        m_help_center: "Help center",
        m_home: "Home",
        m_login: "Log in",
        m_logout: "Sign out",
        m_membership: "Membership",
        m_profile: "My profile",
        m_purchases: "My purchases",
        m_signup: "Sign up",
        more_dates: "+ more dates",
        o_filter_sort_date: "Date",
        o_filter_sort_recommended: "Recommended",
        o_past_3: "Last 3 months",
        o_past_all: "All past events",
        o_tag_all: "All",
        p_loyalty: "This event is bookable for members who have had active memberships during the past $1$ months. Your membership has been active during the past $1$ months and you can therefore book 🎉",
        p_payment_history_bonus: "Do you know you get 100 kr for each member you refer?",
        partners: "Abundo for Partners",
        past: "Past events",
        ph_address: "Street",
        ph_birth_year: "Birth year (write full year, ex. 1960)",
        ph_city: "Choose city",
        ph_company_name: "Company name",
        ph_current_pw: "Current password",
        ph_email: "Email address",
        ph_first_name: "First name",
        ph_gc_amount: "Amount of gift cards",
        ph_gc_code: "Code",
        ph_invite_emails: "Enter email addresses",
        ph_last_name: "Last name",
        ph_name: "Name",
        ph_new_pw: "New password",
        ph_password: "Password",
        ph_phone: "Phone number",
        ph_postcity: "City",
        ph_postcode: "Post code",
        ph_search: "Type something",
        ph_venue: "Choose venue",
        ph_voucher_code: "Voucher code",
        play: "Play",
        press: "Press",
        privacy: "Privacy policy",
        q_onboarding_1: "Where are you mainly going to attend events?",
        q_onboarding_2: "What type of events are you interested in?",
        q_onboarding_3: "What is your phone number?",
        q_onboarding_3m: "We'll let you know when there is new information about an event or if it is cancelled. You can always change your SMS-settings later.",
        resubscribe_popup_button: "Activate",
        resubscribe_popup_text: "Restart your paid membership to book $1$ events in $2$",
        resubscribe_popup_title: "Welcome back!",
        s_reservation_declined: "Reservation declined",
        several_dates: "Multiple dates",
        standby_open_until: "The standby list is open until",
        t_1_ticket: "1 ticket",
        t_book_1_extra_ticket: "1 extra ticket",
        t_book_accept: "By booking you accept",
        t_book_conditions: "our booking conditions",
        t_book_extra_tickets: "extra tickets",
        t_book_free_unbook: "Cancel your tickets for free until",
        t_book_no_free_unbook: "This booking cannot be cancelled without a fee.",
        t_book_read_more: "Read more.",
        t_booking_accept: "When booking you accept the",
        t_booking_amount_1: "$1$ ticket booked",
        t_booking_amount_n: "$1$ tickets booked",
        t_booking_confirmation: "You'll find your ticket on the ‘My bookings’. Cancel at least 24h before the event.",
        t_booking_instructions: "Instructions",
        t_booking_number: "Booking number:",
        t_booking_tos: "booking conditions",
        t_cancel_dialog_1: "Upon cancellation your account will be deactivated on",
        t_cancel_dialog_2: "Any bookings you might have after that date will be cancelled.",
        t_cancel_dialog_comment: "Please leave a comment reflecting why you choose to cancel your subscription. It will help us create a better product!",
        t_cancel_dialog_pause: "You can also pause for another month",
        t_cancel_dialog_unbook: "These tickets will be cancelled",
        t_card_details_why: "We need your card details to start a membership. You will not be charged.",
        t_changeplan_downgrade_1: "The change in your plan will be effective $1$",
        t_changeplan_downgrade_2: "After that date, you will pay 290 kr per month and can only book one ticket per event. One of your tickets will be cancelled for all bookings after $1$.",
        t_changeplan_downgrade_3: "You can book one extra ticket until $1$. You can also change your mind during this time.",
        t_changeplan_event_1: "To be able to book two tickets per event, you need to upgrade your account to a Plus 1 subscription.",
        t_changeplan_event_2: "To upgrade, you pay only the difference for the remaining days of the current billing period, and will pay 550kr/month from your next billing date.",
        t_changeplan_event_3: "Confirm the upgrade by paying the amount below.",
        t_changeplan_total: "Total amount to pay:",
        t_changeplan_upgrade_1: "The upgrade is effective immediately and you only pay the difference for the days remaining in the period you have already paid.",
        t_changeplan_upgrade_2: "From $1$, you will pay 550 kr per month for your new membership.",
        t_changeplan_upgrade_3: "Confirm the upgrade by paying the amount below.",
        t_choose_membership: "Book as many events as you like. All tickets and fees are included in your membership. No commitment period - cancel at any time.",
        t_decline_confirmation: "Are you sure you want to decline the reservation?",
        t_event_duration_h: "h",
        t_event_duration_m: "min",
        t_fb_connect: "Connect your Facebook account to see what your friends are going to",
        t_forgot_sent: "We have sent a password-reset link to your email address",
        t_forgot_spam: "Can't find the email? Check your spam folder.",
        t_giftcard_delivery_email: "Deliver to your email address",
        t_giftcard_delivery_post: "Sent in an envelope to the address you choose",
        t_giftcard_discount: "Includes $1$% discount",
        t_giftcard_payment: "Pay with card or Paypal and we will send the gift card.",
        t_have_reservation: "You have a reservation!",
        t_invite_choose_from: "Choose contacts from",
        t_invite_code: "Your invite code",
        t_invite_code_info: "Your friend can also enter your personal code when they register.",
        t_invite_dialog_choose: "Choose which contacts you want to invite.",
        t_invite_email: "Give a friend a free month with your unique link.",
        t_invite_or: "or",
        t_invite_popup_1: "The link above is your unique referral code which makes it easy to invite friends. Share the link anywhere - in a chat, e-mail, or text etc.",
        t_invite_popup_2: "When a friend registers through the link they get the first month for free.",
        t_invite_popup_3: "For every friend who becomes a paying member of Abundo, you will receive $1$ discount from your next payment.",
        t_invited_saved: "You've saved",
        t_membership_cancelled: "Your membership has been canceled and you can still attend events until $1$",
        t_membership_gc: "Your gift card expires $1$",
        t_membership_next_billing: "Next billing date:",
        t_membership_none: "You don't have an active membership",
        t_membership_pastdue: "We couldn't process the payment for your subscription this month. Please check that the active card is valid, open for internet purchases and that there is money in the account.",
        t_membership_paused: "Your account is paused and will resume on $1$",
        t_membership_pauses: "Your membership will be paused $1$",
        t_more_events_bottom: "Concerts, theater, opera, dance, standup, art exhibitions, film and more. New events become available every day.",
        t_more_events_count: "+ $1$ events",
        t_n_tickets: "tickets",
        t_newsletter_thanks_city: "Thank you! We'll keep you posted on what happens in",
        t_onboarding: "For the best experience, we'd like to ask you three quick questions. You can always change these later in your settings.",
        t_onboarding_category: "Click what you like so we can give you better recommendations!",
        t_onboarding_city: "Where will you mainly go to live events?",
        t_onboarding_phone_1: "We will message you when an event you booked is cancelled or changes time.",
        t_onboarding_phone_2: "You can always change your notification settings later.",
        t_past: "Selection of Abundo events during the last year",
        t_past_archived_1: "This is an archived event.",
        t_past_archived_2: "But we currently have hundreds of active",
        t_past_archived_3: "events we know you'll love!",
        t_pastdue_unbook_warning: "Warning! This booking can unbook automatically. Read more here",
        t_pause_choose_months: "Choose number of months",
        t_pause_dialog: "You keep your account and the subscription will be resumed automatically.",
        t_pause_dialog_unsubscribe: "No thanks, I want to cancel my membership",
        t_ppv_confirmation_1: "You can find your purchased content under \"My purchases\" in the menu.",
        t_ppv_confirmation_2: "A receipt has been sent to",
        t_ppv_confirmation_3: "Welcome to Abundo!",
        t_profile_favorites: "Select your favorite categories for personal tips!",
        t_profile_name: "Please contact us to change your name.",
        t_profile_show_activity: "Choose if you want your friends to see which events you go to.",
        t_promo_code: "Enter your code",
        t_rate_event: "What did you think about",
        t_referral_popup_1: "is a member in Abundo and offers you a free month when you register!",
        t_referral_popup_2: "Abundo is a subscription for hundreds of events in Stockholm and Göteborg.",
        t_referral_popup_3: "No commitment, end whenever you want",
        t_reserve_dialog: "Enter the email addresses of the friends you want to reserve tickets for. The reservation will be kept for three hours and your friend will get an email and a reservation in the \"Standby\" section in \"My bookings\".",
        t_reset_pw: "Enter a new password",
        t_resubscribe_dialog: "You card $1$ will be charged $2$ upon activation",
        t_review_see_more: "Read more",
        t_reviews: "reviews",
        t_signup_accept: "By continuing with your registration you accept our $1$ and $2$.",
        t_signup_already: "Have an account?",
        t_signup_ask_city: "Where are you located?",
        t_signup_ask_email: "What's your email?",
        t_signup_ask_name: "What's your name?",
        t_signup_confirm_email: "Confirm or update your e-mail",
        t_signup_confirm_name: "Confirm or update your name",
        t_signup_dont_activate_text: "Your account will not be charged with a membership fee. We require your credit card details for late cancellation fees only.",
        t_signup_email_already: "Your e-mail is already registered",
        t_signup_email_password: "Enter your password to log in to your existing account.",
        t_signup_enter_email_code: "Enter the 6-digit code sent to your email",
        t_signup_enter_phone: "Enter your phone number",
        t_signup_enter_phone_code: "Enter the 6-digit code sent to you",
        t_signup_gender_age: "Gender and age",
        t_signup_name_why: "For some events we add you to the guest list! Make sure your name matches the name on your ID.",
        t_signup_or: "or",
        t_signup_phone_verified: "Your phone number is verified. You can use it to log in next time.",
        t_signup_privacy: "privacy policy",
        t_signup_select_city: "Select city",
        t_signup_select_subscription: "Choose subscription",
        t_signup_subscription_explain: "Book as many events as you like. All tickets and fees are included in your membership. No commitment - cancel at any time.",
        t_signup_terms: "terms and conditions",
        t_signup_verify_phone: "Verify your phone number",
        t_ticket_activates: "Ticket activated $1$",
        t_ticket_booking: "Booking",
        t_ticket_guestlist: "Guestlist",
        t_ticket_nonrefundable: "Non refundable",
        t_ticket_people: "$1$ people",
        t_ticket_person: "$1$ person",
        t_ticket_personal: "Booking personal to $1$",
        t_ticket_row: "Row $1$",
        t_ticket_seat: "Seat $1$",
        t_video_live_members: "This content is included for Abundo subscribers",
        t_video_live_now: "Live now",
        t_video_not_active: "Activate your account to enjoy this content.",
        t_video_not_available: "This content is no longer available",
        t_video_remind_confirmation: "We'll send you a reminder by email two hours before the stream starts.",
        t_video_reminder: "You will be reminded 2 hours before the start",
        t_video_replay: "This is a replay from $1$",
        t_video_starts: "The live stream starts",
        t_video_until: "Available until $1$.",
        td_invite_accepted: "Accepted",
        td_invite_sent: "Sent",
        td_payment_failed: "Failed",
        td_payment_giftcard: "Gift card",
        td_payment_membership: "Membership",
        td_payment_purchase: "Purchase",
        td_payment_refund: "Refund",
        td_payment_tickets: "Tickets",
        td_payment_upgrade: "Upgrade",
        td_payment_valid_until: "Valid until",
        terms: "Terms of use",
        th_payment_date: "Date",
        th_payment_description: "Description",
        th_payment_method: "Payment method",
        th_payment_total: "Total",
        tt_accept_latest: "Accept latest",
        tt_book_before: "Book latest at $1$",
        w_cantbook_already: "You already have an active booking to this event.",
        w_cantbook_been: "You have already been to this event.\nWe have this restriction so that all our members can enjoy our most popular shows.",
        w_cantbook_cancel: "Your membership is no longer active on the date of the event. You can resume your membership in \"My account\"",
        w_cantbook_ended: "This event has already taken place",
        w_cantbook_expired: "This reservation is no longer available",
        w_cantbook_gc: "Your membership is no longer active on the date of the event. You can start a membership automatically when your gift card expires in \"My account\"",
        w_cantbook_limit: "You already have two active bookings. You can make a new booking when you have gone to any of the events or if you cancel one of your active bookings.",
        w_cantbook_loyalty: "This event is bookable for members who have had an active membership during the past $1$ months. You have $2$ days until you are able to book this event!",
        w_cantbook_loyalty_inactive: "This event is bookable for members who have had active memberships during the past $1$ months. Your membership is inactive paused. To book, you need to reactivate your membership and keep it active for $1$ consecutive months.",
        w_cantbook_notickets: "No tickets available.",
        w_cantbook_pastdue: "We couldn't process the payment for your subscription this month. That must be fixed before you can book",
        w_cantbook_paused: "Your account is paused. Resume your membership in \"My account\"",
        w_cantbook_sameday: "You already have a booking on this date. You can't have two active bookings on the same date.",
        w_dismiss_rating: "You can always rate past events in \"My bookings\"",
        w_late_unbook: "This is a late unbooking. You will be charged 100 kr per ticket.",
        w_membership_recovered: "Thanks! Your payment was successful and you can book again",
        w_standby: "You are now in standby.",
        w_standby_1: "You are now in standby for one ticket.",
        w_standby_2: "You are now in standby for two tickets.",
        w_standby_first: "This event is fully booked but it might be possible to get a booking. Click \"Standby\" to get a reservation when there are tickets available.",
        w_standby_info: "When more tickets are available we will randomly reserve tickets to members on the standby list",
        w_unbook: "Are you sure you want to unbook?",
        w_unbook_one: "Are you sure you want to cancel one ticket?",
    },
    ui: {
        back_to: "Back to",
        button_cancel: "CANCEL",
        button_delete: "DELETE",
        button_no: "NO",
        button_ok: "OK",
        button_save: "SAVE",
        button_send: "SEND",
        button_yes: "YES",
        img_drop: "Drop image",
        inv_email: "This is not a valid email address",
        inv_number: "The number is not within the valid interval",
        inv_password: "Password must be at least 6 characters long",
        inv_required: "This field is required",
        select_dates: "Select dates",
    },
    y: {
        currency_format: {
            EUR: "€$1$",
            SEK: "$1$ kr",
        },
        days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        short_days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        short_months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    },
};

$i18n_specs['sv'] = {
    aa: {
        b_add: "Lägg till",
        b_add_pictures: "+ Lägg till fler bilder",
        b_add_recipient: "+ Lägg till mottagare",
        b_add_session: "+ Lägg till session",
        b_add_tickets: "ADDERA BILJETTER",
        b_add_user: "LÄGG TILL ANVÄNDARE",
        b_booking_list: "BOKNINGSLISTA",
        b_change: "ÄNDRA",
        b_create_event: "SKAPA NYTT EVENEMANG",
        b_download: "Ladda ner",
        b_download_pdf: "Ladda ner som PDF",
        b_duplicate: "DUPLICERA",
        b_edit: "REDIGERA",
        b_import: "Importera",
        b_import_selected: "Importera valda sessioner",
        b_missing_info: "Fyll i uppgifter här.",
        b_save_add_dates: "Spara och lägg till datum",
        b_save_send: "Spara och skicka för godkännande",
        b_send_booking_list: "Skicka bokningslista till",
        b_session_cancel: "TA BORT",
        b_update: "Updatera",
        c_amount: "Antal",
        c_booked: "bokade",
        c_booking_number: "Bokningsnummer",
        c_date: "Datum",
        c_event: "Evenemang",
        c_event_name: "Namn",
        c_next_date: "Nästa datum",
        c_payment_amount: "Summa",
        c_period: "Period",
        c_review: "Omdöme",
        c_standby: "i standby",
        c_status: "Status",
        c_ticket_amount: "Antal biljetter",
        c_tickets: "Biljetter",
        c_tickets_available: "$1$ tickets available",
        c_total: "Summa",
        c_user_name: "Namn",
        f_address: "Adress",
        f_choose_venue: "Välj plats",
        f_city: "Stad",
        f_company_name: "Företagsnamn",
        f_date_time: "Datum \u0026 Tid",
        f_description: "Beskriv ditt evenemang",
        f_dont_feature: "Visa inte mitt evenemang på Abundos startsida",
        f_dont_feature_sub: "Vi visar inte ditt evenemang för icke-inloggade medlemmar",
        f_dont_market: "Marknadsför inte detta evenemang utanför Abundos plattform",
        f_dont_market_sub: "Vi kommer inte att dela ditt evenamng på sociala medier",
        f_dropin: "Drop-in session",
        f_duration: "Sätt evenemangets längd (minuter)",
        f_email: "E-postadress",
        f_end_time: "Till",
        f_event_name: "Namnge ditt evenemang",
        f_genre: "Genre",
        f_i_instructions: "Beskriv hämtningsanvisningar",
        f_i_regular_price: "Skriv in evenemangets ordinarie biljettpris",
        f_i_sales_end: "Sätt bokningsstopp (timmar innan start)",
        f_i_sales_end_sub: "Vi rekommenderar 2 timmar innan evenemangets starttid.",
        f_instructions: "Hämtningsanvisningar",
        f_list_recipients: "Mottagare av gästlista",
        f_media_links: "Lägg till medialänkar",
        f_org_number: "Organisationsnummer",
        f_payout_destination: "Konto för utbetalning",
        f_permissions: "Behörigheter",
        f_pictures: "Bilder",
        f_producer: "Producer",
        f_regular_price: "Ordinarie biljettpris",
        f_sales_end: "Bokningsstopp (timmar innan starttid)",
        f_ticket_amount: "Antal biljetter",
        f_tickets_per_session: "Biljetter per session",
        f_venue: "Spelställe",
        h_add_team: "Lägg till användare till ditt team",
        h_available_sessions: "TILLGÄNGLIGA SESSIONER",
        m_account: "Kontouppgifter",
        m_handle_events: "Hantera evenemang",
        m_imported: "Imported",
        m_logout: "Logga ut",
        m_reviews: "Omdömen",
        m_sales: "Sales",
        m_summaries: "Sammanställningar",
        m_team: "Team",
        m_upcoming_bookings: "Kommande bokningar",
        n_bookings: "BOKNINGAR",
        n_new_event: "NYTT EVENEMANG",
        n_session: "SESSION",
        o_active: "LIVE",
        o_all_events: "Alla evenemang",
        o_bookings: "bokningar",
        o_events: "evenemang",
        o_invoices: "sammanställningar",
        o_past: "TIDIGARE",
        o_reviews: "omdömen",
        o_tickets: "biljetter",
        o_tickets_sold: "biljetter sålda",
        o_total_sales: "total försäljning",
        o_users: "användare",
        tb_company_info: "Företagets uppgifter",
        tb_date_time: "Datum \u0026 Tider",
        tb_default_info: "Standardinfo",
        tb_event_description: "Evenemangsbeskrivning",
        tb_user_info: "Mina uppgifter",
        tt_add_amount: "Antal medlemmar som vill gå om du adderar fler biljetter.",
        tt_create_event: "Skapa evenemang",
        tt_edit: "Ändra",
        tt_missing_info: "Evenemanget saknar information",
        tt_publish_pending: "Väntar på publicering",
        tt_session_booked: "$1$ bokade + $2$ reserverade",
        v_paid_on: "Betald $1$",
        v_started: "Initierad",
        w_cancel_booked: "Det är inbokade medlemmar till den här speltiden. Om du tar bort speltiden kommer alla inbokade medlemmar automatiskt att informeras. Är du säker på att du vill ta bort speltiden?",
        w_missing_info: "Vi saknar viktiga företagsdetaljer.",
        w_publish_date: "Det här datumet kommer att publiceras $1$",
        w_session_booked: "Det är inbokade medlemmar till den här speltiden. Om du ändrar speltiden kommer alla inbokade medlemmar automatiskt att informeras om ändringen. Är du säker på att du vill ändra speltid enligt följande?",
        w_session_booked_new: "Ny tid: $1$",
        w_session_booked_previous: "Tidigare tid: $1$",
    },
    pr: {
        account_account_number: "Kontonummer",
        account_event_defaults: "Standardinfo för events",
        account_invoice_details: "Kontouppgifter",
        account_mobile_title: "Kontouppgifter",
        account_my_details: "Mina uppgifter",
        account_payment_details: "Uppgifter för utbetalning",
        account_payment_details_description: "Till vilket konto ska Abundo utbetala?",
        account_title: "Kontouppgifter",
        add_tickets_apply: "Spara",
        add_tickets_current_amount: "Nuvarande antal: $1$ biljetter",
        add_tickets_placeholder: "Sätt nytt antal",
        add_tickets_title: "Öka biljettantal",
        booking_list_mobile_title: "Bokningslista",
        booking_list_search: "Sök efter medlem",
        booking_list_send_tickets: "Vid bokningsstopp skickar du bokat antal biljetter till $1$",
        booking_list_title: "Bokningslista",
        dashboard_earnings: "Intäkter",
        dashboard_last_payment: "Senaste utbetalning",
        dashboard_none: "None",
        dashboard_tickets_booked: "Bokade biljetter",
        dashboard_total: "Totalt",
        error_invalid_media_link: "Ogiltig medielänk",
        event_add_link: "Lägg till",
        event_add_media_link: "Klistra in medialänk",
        event_booking_list: "Bokningslista",
        event_bookings_ticket: "Ticket $1$",
        event_bookings_unknown_seat: "Unknown seat",
        event_cancel: "Ta bort event",
        event_copy_url: "Kopiera URL",
        event_create: "Skapa event",
        event_create_new_session: "Lägg till session",
        event_duplicate: "Duplicera event",
        event_edit: "Redigera event",
        event_email_external: "Eller ange extern e-postadress",
        event_email_team: "Välj teammedlem",
        event_genre: "Sätt genre",
        event_genre_add: "+ Lägg till genre",
        event_link_copied: "Länk kopierad!",
        event_photo_credits: "Fotokreditering",
        event_save: "Spara",
        event_send_for_review: "Skicka för granskning",
        event_show: "Visa event",
        events_add_sessions: "Lägg till session",
        events_add_tickets: "Öka biljettantal",
        events_mobile_title: "Hantera events",
        events_more: "+$1$ till",
        events_status_draft: "Utkast",
        events_status_imported: "Importerad",
        events_status_live: "Live",
        events_status_past: "Tidigare",
        events_status_sent: "Granskas",
        events_title: "Hantera dina events",
        events_tooltip_amount_managed: "Hanteras i ordinarie biljettsystem",
        filter_cities_all: "All cities",
        filter_city: "Stad",
        filter_date: "Datum",
        filter_event: "Event",
        filter_event_imported: "Importerade",
        filter_event_live: "Live",
        filter_event_previous: "Tidigare",
        filter_event_unpublished: "Opublicerade",
        filter_events: "Events",
        filter_events_all: "Alla events",
        filter_filter: "Filtrera",
        filter_name: "Namn",
        filter_search: "Sök",
        filter_sort: "Sortera",
        filter_time_period: "Tidsperiod",
        filter_venue: "Spelplats",
        filter_venues_all: "Alla spelställen",
        filter_year: "År",
        filter_year_all: "Alla år",
        menu_account: "Inställningar",
        menu_dashboard: "Dashboard",
        menu_events: "Events",
        menu_integration: "Integrationer",
        menu_logged_in_as: "Logged in as",
        menu_new_event: "Nytt event",
        menu_payments: "Utbetalningar",
        menu_reviews: "Omdömen",
        menu_statistics: "Statistik",
        menu_team: "Användare",
        menu_upcoming: "Bokningar",
        payments_mobile_title: "Intäkter: $1$",
        payments_paid: "Utbetalat $1$",
        payments_pending: "Hanteras",
        payments_tickets: "$1$ biljetter",
        payments_title: "Totala intäkter: $1$",
        reviews_download: "Ladda ner som PDF",
        reviews_mobile_title: "Omdömen",
        reviews_search: "Sök events",
        reviews_send: "Skicka",
        reviews_summary: "Sammanfattning",
        reviews_title: "Omdömen: alla events",
        session_booking_stop: "Sätt bokningsstopp",
        session_create: "Skapa session",
        session_date: "Datum",
        session_edit_instructions: "Edit instructions",
        session_ticket_type: "Ticket type",
        session_time: "Tid",
        session_update: "Uppdatera session",
        sessions_bookings: "$1$ bokade",
        sessions_col_bookings: "Bokningar",
        sessions_col_closes_at: "Stänger",
        sessions_col_date_time: "Datum och tid",
        sessions_col_event: "Event",
        sessions_col_standby: "Standby",
        sessions_col_ticket_type: "Biljettyp",
        sessions_col_venue: "Spelplats",
        sessions_mobile_title: "Kommande bokningar",
        sessions_more_tickets: "Öka biljettantal",
        sessions_open_until: "Öppen till $1$",
        sessions_search: "Sök",
        sessions_standby: "$1$ standby",
        sessions_title: "Bokningar för kommande datum",
        sessions_tooltip_eticket: "När bokningen stängt $1$ skickar du totala antalet bokade biljetter i en order från ert biljettsystem till:\n\ntickets@abundolive.se (Sweden)\ntickets@abundolive.de (Germany)",
        sessions_tooltip_guestlist: "När bokningen stänger $1$ skickas en digital gästlista och PDF till $2$.",
        team_add_member: "Lägg till användare",
        team_admin: "Admin",
        team_admin_description: "Full behörighet inklusive hantering av användare",
        team_bookings: "Bokningar",
        team_bookings_description: "Tillgång till och hantering av bokningslistor",
        team_economy: "Ekonomi",
        team_economy_description: "Tillgång till ekonomisk data och avräkningar",
        team_email_address: "E-postadress",
        team_events: "Events",
        team_events_description: "Tillgång till och hantering av events",
        team_invite: "Bjud in användare",
        team_invited_users: "Inbjudna användare",
        team_limited_access: "Begränsad behörighet",
        team_mobile_title: "$1$ team",
        team_remove_confirm: "Är du säker på att du vill ta bort den här användaren?",
        team_send_invite: "Skicka inbjudan",
        team_title: "$1$ team",
        team_update_permissions: "Uppdatera behörigheter",
        ticket_eticket: "E-biljetter",
        ticket_guestlist: "Gästlista",
    },
    tl: {
        o_filter_dates: {
            range: "Datum",
            today: "Idag",
            tomorrow: "Imorgon",
            week: "Denna vecka",
            weekend: "I helgen",
        },
        o_gender: {
            female: "Kvinna",
            male: "Man",
            other: "Annat",
        },
        o_giftcard_delivery: {
            digital: "E-post",
            post: "Post",
        },
        td_payment_addons: {
            bonus: "Bonus",
            late_cancel: "Avbokningsavgift",
        },
        about_us: "Om oss",
        b_accept: "Acceptera",
        b_add_standby: "Lägg till standby-plats",
        b_add_ticket: "Lägg till biljett",
        b_all_events: "Till alla evenemang",
        b_ap_login: "Logga in med Apple",
        b_apply_code: "Använd kod",
        b_back: "Tillbaka",
        b_back_to_events: "Tillbaka till alla evenemang",
        b_book: "Boka",
        b_booked: "Bokad",
        b_buy_more: "Köp fler biljetter",
        b_cancel: "Avbryt",
        b_change_payment: "Ändra betalsätt",
        b_change_plan: "Ändra medlemskap",
        b_change_pw: "Ändra lösenord",
        b_choose: "Välj",
        b_choose_kind: "Välj",
        b_close: "Stäng",
        b_confirm: "Bekräfta",
        b_confirm_booking: "Bekräfta bokning",
        b_continue: "Fortsätt",
        b_copy_code: "Kopiera kod",
        b_copy_link: "Kopiera länk",
        b_decline: "Avböj",
        b_done: "Klar",
        b_enter_gc: "Ange koden",
        b_extend_pause: "Förläng paus",
        b_fb_connect: "Koppla till Facebook",
        b_fb_continue: "Fortsätt med Facebook",
        b_fb_login: "Logga in med Facebook",
        b_fill_later: "Fyll i senare",
        b_filter_clear: "Rensa filter",
        b_filter_show: "Visa resultat",
        b_forgot: "Glömt lösenord?",
        b_giftcard_confirm_info: "Bekräfta uppgifter",
        b_giftcard_redeem: "Lös in presentkort",
        b_have_code: "Har du en kod?",
        b_how_it_works: "Så fungerar det",
        b_invite_dialog_send: "Skicka inbjudningar",
        b_invite_friends_here: "Bjud in vänner här.",
        b_invited_resend: "Skicka igen",
        b_leave_comment: "Vill du lämna en kommentar?",
        b_lets_go: "Kör!",
        b_login: "Logga in",
        b_login_email: "Logga in med e-post",
        b_login_email_instead: "Logga in med e-post istället",
        b_login_phone: "Logga in med telefonnummer",
        b_loyalty_info: "Info",
        b_membership_choose: "Välj medlemskap",
        b_membership_resume: "Återuppta medlemskap",
        b_more_dates: "Visa fler datum",
        b_next: "Nästa",
        b_not_member: "Är du inte medlem? Registrera dig här",
        b_not_now: "Inte nu",
        b_ok: "OK",
        b_pause: "Pausa",
        b_pay: "Betala $1$ $2$",
        b_pay_autogiro: "Autogiro",
        b_pay_autogiro_once: "Bankbetalning med Trustly",
        b_pay_card: "Betalkort",
        b_payment_receipt: "Kvitto",
        b_read_more: "Läs mer",
        b_read_more_abundo: "Läs mer om Abundo",
        b_renew_subscription: "Förläng medlemskap",
        b_resend_code: "Skicka kod igen",
        b_reserve: "Reservera",
        b_reset_pw: "Återställ lösenord",
        b_resubscribe_change: "Ändra betalsätt / medlemskap",
        b_resume_now: "Återuppta nu",
        b_save: "Spara",
        b_see_all: "Se alla",
        b_see_booking: "Se min bokning",
        b_see_event: "Se evenemanget",
        b_send: "Skicka",
        b_send_invites: "Skicka inbjudningar",
        b_share: "Dela",
        b_show_tickets: "Visa biljetter",
        b_signup_phone: "Registrera dig med telefonnummer",
        b_skip: "Hoppa över",
        b_standby: "Standby",
        b_standby_remove: "Ta bort mig från listan",
        b_start_for: "Starta för",
        b_start_watching: "Börja titta",
        b_ticket_pdf: "Öppna PDF-biljett",
        b_to_my_bookings: "Till mina bokningar",
        b_try_again: "Försök igen",
        b_try_month: "Prova en månad gratis",
        b_unbook: "Avboka",
        b_unbook_one: "Avboka en biljett",
        b_undo_cancel: "Ångra uppsägningen",
        b_unsubscribe: "Avsluta",
        b_video_account: "Mitt konto",
        b_video_buy_amount: "Köp för $1$ kr",
        b_video_remind: "Påminn mig",
        b_voucher: "Värdekod?",
        become_member: "Bli medlem",
        bnr_cancelled: "Ditt medlemskap är avslutat.",
        bnr_cancelled_b: "Återuppta medlemskap.",
        bnr_none: "Du har inget aktivt medlemskap.",
        bnr_none_b: "Välj medlemskap.",
        bnr_pastdue: "Vi har inte kunnat genomföra betalning.",
        bnr_pastdue_b: "Åtgärda.",
        bnr_paused: "Ditt medlemskap är pausat.",
        bnr_paused_b: "Återuppta medlemskap.",
        bnr_pending_cancel: "Ditt medlemskap kommer avslutas.",
        bnr_pending_cancel_b: "Ångra uppsägning.",
        booking_starts: "Börjar",
        cb_notifications_event_info: "Viktig info om dina bokningar",
        cb_notifications_standby: "Standby-reservationer",
        cb_profile_show_activity: "Visa vad jag ska gå på",
        consent_accept: "Acceptera alla cookies",
        consent_link: "policy för cookies",
        consent_preferences: "Cookieinställningar",
        consent_text: "Vi använder cookies och liknande teknologier för att anpassa innehåll, skräddarsy och mäta annonser och tillhandahålla en bättre upplevelse. Genom att klicka på OK eller slå på ett alternativ i Inställningar för cookies godkänner du detta enligt vår $1$. För att ändra inställningar eller dra tillbaka ditt samtycke ber vi dig att uppdatera dina Inställningar för cookies.",
        consent_title: "Din integritet",
        e_bookings: "Du har inga bokningar.",
        e_invalid_code: "Ogiltig kod",
        events: "Evenemang",
        faq: "Vanliga frågor",
        for_companies: "För företag",
        giftcard_b2b: "Presentkort för företag",
        h_booking: "Dina biljetter",
        h_booking_confirmation: "Bokning bekräftad",
        h_bookings: "Mina bokningar",
        h_bookings_current: "AKTUELLA",
        h_bookings_past: "ARKIV",
        h_bookings_standby: "STANDBY",
        h_cancel_dialog: "Avsluta medlemskap",
        h_card_details: "Kortuppgifter",
        h_change_plan_dialog: "Viktig information",
        h_choose_membership: "Välj medlemskap",
        h_city: "Välj stad",
        h_create_account: "Skapa konto",
        h_extend_pause: "Förläng paus",
        h_filter: "Filter",
        h_filter_category: "Kategori",
        h_filter_city: "Stad",
        h_filter_date: "Datum",
        h_filter_sort: "Sortera efter",
        h_forgot: "Glömt lösenord?",
        h_friends: "Vänner",
        h_giftcard_contact: "Dina kontaktuppgifter",
        h_giftcard_delivery: "4. Välj leveranssätt",
        h_giftcard_delivery_address: "Leveransadress",
        h_giftcard_kind: "3. Välj medlemskap",
        h_giftcard_kind_2: "2. Välj medlemskap",
        h_giftcard_months: "1. Välj antal månader",
        h_giftcard_quantity: "2. Välj antal presentkort",
        h_instructions: "Instruktioner",
        h_invite_dialog: "Bjud in kontakter",
        h_invite_email: "Bjud in via e-post",
        h_invite_link: "Bjud in via länk",
        h_invite_popup_1: "Dela din länk",
        h_invite_popup_2: "Din vän får en månad gratis",
        h_invite_popup_3: "Du får $1$",
        h_invite_reward: "Du får $1$ varje gång du bjuder en vän på en gratis månad!",
        h_invited: "Dina inbjudna vänner",
        h_language: "Språk",
        h_login: "Logga in",
        h_membership: "Mitt medlemskap",
        h_membership_have_gc: "Har du ett presentkort?",
        h_no_commitment: "Ingen bindningstid, avsluta när du vill",
        h_onboarding: "Vi vill lära känna dig lite bättre",
        h_onboarding_category: "Dina favoriter?",
        h_onboarding_city: "Din stad?",
        h_onboarding_phone: "Ditt nummer?",
        h_past: "Tidigare på Abundo",
        h_pause_dialog: "Ta en paus?",
        h_payment: "Betalning",
        h_payment_history: "Betalhistorik",
        h_profile: "Min profil",
        h_profile_favorites: "Mina favoriter",
        h_profile_pw: "Ändra lösenord",
        h_redeem_gc: "Ange koden som finns på presentkortet",
        h_referral_popup: "Inbjudan från",
        h_reserve_dialog: "Reservera",
        h_reset_pw: "Återställ lösenord",
        h_resubscribe_dialog: "Återuppta medlemskap",
        h_reviews: "Omdömen",
        h_search: "Sökresultat för",
        h_signup: "Skapa profil",
        h_signup_confirm_info: "Bekräfta din information",
        h_signup_with_email: "Registrera dig med din e-post",
        h_standby_first: "Standby",
        h_thanks: "Tack!",
        h_video_not_active: "Ditt konto är ej aktivt",
        h_voucher: "Värdekod",
        how_it_works: "Så fungerar Abundo",
        invite: "Bjud in vänner",
        jobs: "Jobba med oss",
        l_my_account: "Mitt konto",
        l_read_more_here: "Läs mer här",
        m_bookings: "Mina bokningar",
        m_friends: "Vänner",
        m_giftcard: "Presentkort",
        m_help_center: "Hjälpcenter",
        m_home: "Hem",
        m_login: "Logga in",
        m_logout: "Logga ut",
        m_membership: "Medlemskap",
        m_profile: "Min profil",
        m_purchases: "Mina köp",
        m_signup: "Skapa konto",
        more_dates: "+ fler datum",
        o_filter_sort_date: "Datum",
        o_filter_sort_recommended: "Förslag",
        o_past_3: "Senaste 3 månader",
        o_past_all: "Alla tidigare evenemang",
        o_tag_all: "Allt",
        p_loyalty: "Det här evenemanget är bokningsbart för medlemmar som haft aktiva medlemskap de senaste $1$ månaderna. Ditt medlemskap har varit aktivt senaste $1$ månaderna och du kan därmed boka 🎉",
        p_payment_history_bonus: "Du vet väl att du får 100 kr bonus för varje medlem du värvar?",
        partners: "Bli partner",
        past: "Tidigare föreställningar",
        ph_address: "Gatuadress",
        ph_birth_year: "Födelseår (Skriv in fyra siffror, ex. 1960)",
        ph_city: "Välj stad",
        ph_company_name: "Företag",
        ph_current_pw: "Befintligt lösenord",
        ph_email: "E-postadress",
        ph_first_name: "Förnamn",
        ph_gc_amount: "Antal presentkort",
        ph_gc_code: "Kod",
        ph_invite_emails: "Ange e-postadresser",
        ph_last_name: "Efternamn",
        ph_name: "Namn",
        ph_new_pw: "Nytt lösenord",
        ph_password: "Lösenord",
        ph_phone: "Telefonnummer",
        ph_postcity: "Ort",
        ph_postcode: "Postnummer",
        ph_search: "Skriv något...",
        ph_venue: "Välj scen",
        ph_voucher_code: "Kod",
        play: "Play",
        press: "Press",
        privacy: "Integritetspolicy",
        q_onboarding_1: "Var kommer du främst gå på evenemang?",
        q_onboarding_2: "Vilken typ av evenemang gillar du?",
        q_onboarding_3: "Vad är ditt telefonnummer?",
        q_onboarding_3m: "Vi meddelar dig när ett bokat evenemang  ändras eller blir inställt. Du kan alltid ändra dina SMS inställningar senare.",
        resubscribe_popup_button: "Aktivera",
        resubscribe_popup_text: "Återstarta medlemskap för att boka $1$ evenemang i $2$",
        resubscribe_popup_title: "Välkommen tillbaka!",
        s_reservation_declined: "Reservation avböjd",
        several_dates: "Flera datum",
        standby_open_until: "Standbylistan är öppen till den",
        t_1_ticket: "1 biljett",
        t_book_1_extra_ticket: "1 extra biljett",
        t_book_accept: "Vid bokning godkänner du",
        t_book_conditions: "bokningsvillkoren",
        t_book_extra_tickets: "extra biljetter",
        t_book_free_unbook: "Fri avbokning till",
        t_book_no_free_unbook: "Denna bokning kan ej avbokas utan avgift.",
        t_book_read_more: "Läs mer.",
        t_booking_accept: "Vid bokning godkänner du",
        t_booking_amount_1: "$1$ biljett bokad",
        t_booking_amount_n: "$1$ biljetter bokade",
        t_booking_confirmation: "Du hittar din biljett på sidan ‘Mina bokningar’. Avboka senast 24h före evenemanget.",
        t_booking_instructions: "Instruktioner",
        t_booking_number: "Bokningsnummer:",
        t_booking_tos: "bokningsvillkoren",
        t_cancel_dialog_1: "Vid uppsägning inaktiveras ditt konto",
        t_cancel_dialog_2: "De bokningar som du har efter det datumet kommer att automatiskt att avbokas.",
        t_cancel_dialog_comment: "Lämna gärna en kommentar om varför du vill avsluta ditt medlemskap. Det hjälper oss att skapa en bättre tjänst!",
        t_cancel_dialog_pause: "Du kan även välja att pausa ytterligare en månad.",
        t_cancel_dialog_unbook: "Dessa biljetter kommer att avbokas",
        t_card_details_why: "I och med att ett abonnemang startas behöver vi dina kortuppgifter. Ingen transaktion genomförs.",
        t_changeplan_downgrade_1: "Vid ändring av ditt medlemskap kommer ändringen träda i kraft $1$",
        t_changeplan_downgrade_2: "Du kommer från och med det datumet betala 290 kr i månaden och endast kunna boka en biljett per föreställning. För alla dina bokningar efter $1$ kommer en av biljetterna bokas av.",
        t_changeplan_downgrade_3: "Fram till $1$ kan du fortsätta boka en extrabiljett. Du kan även under denna period ångra din ändring.",
        t_changeplan_event_1: "För att kunna boka två biljetter per evenemang behöver du uppgrader ditt konto till Plus 1.",
        t_changeplan_event_2: "Vid uppgradering betalar du mellanskillnaden från din redan betalda period och från och med din nästa debitering betalar du 550kr/mån.",
        t_changeplan_event_3: "Bekräfta uppgraderingen genom att betala summan nedan.",
        t_changeplan_total: "Summa att betala:",
        t_changeplan_upgrade_1: "Uppgraderingen träder i kraft direkt och du betalar endast mellanskillnaden för återstående dagar av din redan betalda period.",
        t_changeplan_upgrade_2: "Från och med $1$ kommer du betala 550 kr i månaden för ditt nya medlemskap.",
        t_changeplan_upgrade_3: "Bekräfta uppgraderingen genom att betala summan nedan.",
        t_choose_membership: "Boka hur många evenemang du vill. Alla biljetter och avgifter ingår i ditt medlemskap. Ingen bindningstid - Avsluta när du vill.",
        t_decline_confirmation: "Är du säker på att du vill avböja reservationen?",
        t_event_duration_h: "tim",
        t_event_duration_m: "min",
        t_fb_connect: "Koppla ihop med Facebook så kan du logga in enklare och se vad dina vänner ska gå på.",
        t_forgot_sent: "Vi har nu skickat en återställningslänk till e-postadressen",
        t_forgot_spam: "Hittar du inget e-post? Kolla din skräpkorg.",
        t_giftcard_delivery_email: "Levereras direkt till din e-postadress",
        t_giftcard_delivery_post: "Skickas i kuvert till dig eller mottagaren",
        t_giftcard_discount: "Inklusive $1$% rabatt",
        t_giftcard_payment: "Fyll i dina kortuppgifter så skickar vi presentkortet till dig.",
        t_have_reservation: "Du har en reservation!",
        t_invite_choose_from: "Välj kontakter från",
        t_invite_code: "Din inbjudningskod",
        t_invite_code_info: "Din vän kan även ange din personliga kod när de registrerar sig.",
        t_invite_dialog_choose: "Välj vilka kontakter du vill bjuda in.",
        t_invite_email: "Bjud en vän på första månaden gratis med din unika länk.",
        t_invite_or: "eller",
        t_invite_popup_1: "Länken här ovan är din unika inbjudningslänk som gör det enkelt att bjuda in vänner. Dela länken var som helst - i en chatt, mail, sms, etc.",
        t_invite_popup_2: "När en vän registrerar sig via din länk får de första månaden gratis.",
        t_invite_popup_3: "För varje vän som blir betalande medlem på Abundo får du $1$ som dras av på din kommande betalning.",
        t_invited_saved: "Du har sparat",
        t_membership_cancelled: "Ditt medlemskap är uppsagt men du kan fortfarande gå på evenemang fram till $1$",
        t_membership_gc: "Ditt presentkort löper ut $1$",
        t_membership_next_billing: "Nästa debitering:",
        t_membership_none: "Du har inget aktivt medlemskap",
        t_membership_pastdue: "Vi har inte lyckats genomföra betalningen för ditt medlemskap den här månaden. Var god kontrollera att ditt registrerade kort är giltigt, inte är spärrat för internetköp och att det finns pengar på kontot.",
        t_membership_paused: "Ditt konto är pausat och återupptas $1$",
        t_membership_pauses: "Ditt medlemskap pausas $1$",
        t_more_events_bottom: "Konserter, teater, opera, dans, stand-up, film, konstutställningar och mer - nya evenemang blir tillgängliga varje dag.",
        t_more_events_count: "+ $1$ evenemang",
        t_n_tickets: "biljetter",
        t_newsletter_thanks_city: "Tack! Vi håller dig uppdaterad om vad som händer i",
        t_onboarding: "För den bästa upplevelsen så har vi tre snabba frågor till dig. Du kan även redigera dessa senare i din profil.",
        t_onboarding_category: "Klicka på allt du gillar så vi kan tipsa dig bättre!",
        t_onboarding_city: "I vilken stad kommer du främst gå på evenemang i?",
        t_onboarding_phone_1: "Vi meddelar dig när ett bokat evenemang ändras eller blir inställt.",
        t_onboarding_phone_2: "Du kan alltid ändra dina sms-inställningar senare.",
        t_past: "Urval av föreställningar på Abundo senaste året",
        t_past_archived_1: "Detta är ett arkiverat evenemang.",
        t_past_archived_2: "Men vi har just nu hundratals aktiva",
        t_past_archived_3: "evenemang vi vet att du kommer älska!",
        t_pastdue_unbook_warning: "Obs! Denna bokning kan avbokas automatiskt. Läs mer här",
        t_pause_choose_months: "Välj antal månader",
        t_pause_dialog: "Du behåller din plats hos oss och medlemskapet återupptar sedan automatiskt. Under dina pausade månad betalar du ingen avgift.",
        t_pause_dialog_unsubscribe: "Nej tack, jag vill avsluta mitt medlemskap",
        t_ppv_confirmation_1: "Du hittar alltid ditt köpta innehåll under \"Mina köp\" i menyn.",
        t_ppv_confirmation_2: "Kvitto har skickats till",
        t_ppv_confirmation_3: "Välkommen till Abundo!",
        t_profile_favorites: "Välj dina favoritkategorier så att vi kan ge dig personliga tips!",
        t_profile_name: "Kontakta oss om du vill ändra ditt namn.",
        t_profile_show_activity: "Välj om du vill att vänner ska se vilka evenemang du ska gå på.",
        t_promo_code: "Fyll i din kod",
        t_rate_event: "Vad tyckte du om",
        t_referral_popup_1: "är medlem i Abundo och bjuder dig på en gratis månad när du registrerar dig nedan!",
        t_referral_popup_2: "Abundo är ett abonnemang för hundratals evenemang i Stockholm och Göteborg.",
        t_referral_popup_3: "Ingen bindningstid, avsluta när du vill",
        t_reserve_dialog: "Fyll i e-postadresserna till dina vänner du vill reservera till. En reservation hålls i tre timmar och din vän blir meddelad via e-post samt får en reservation under fliken \"Standby\" under \"Mina bokningar\".",
        t_reset_pw: "Skriv in ett nytt lösenord",
        t_resubscribe_dialog: "Vid aktivering kommer vi debitera ditt kort $1$ med $2$",
        t_review_see_more: "Läs mer",
        t_reviews: "omdömen",
        t_signup_accept: "Genom att fortsätta registreringen godkänner du våra $1$ och vår $2$.",
        t_signup_already: "Har du redan ett konto?",
        t_signup_ask_city: "Var befinner du dig?",
        t_signup_ask_email: "Vad är din e-postadress?",
        t_signup_ask_name: "Vad heter du?",
        t_signup_confirm_email: "Bekräfta eller uppdatera din e-post",
        t_signup_confirm_name: "Bekräfta eller ändra ditt namn",
        t_signup_dont_activate_text: "Your account will not be charged with a membership fee. We require your credit card details for late cancellation fees only.",
        t_signup_email_already: "Din e-postadress är redan registrerad",
        t_signup_email_password: "Ange ditt lösenord för att logga in på ditt befintliga konto.",
        t_signup_enter_email_code: "Ange den 6-siffriga koden som skickats till din e-post",
        t_signup_enter_phone: "Fyll i ditt telefonnummer",
        t_signup_enter_phone_code: "Ange den 6-siffriga kod som skickats till dig",
        t_signup_gender_age: "Kön och ålder",
        t_signup_name_why: "För vissa evenemang läggs du till på gästlista. Se till att ditt namn stämmer överens med namnet på din legitimation.",
        t_signup_or: "eller",
        t_signup_phone_verified: "Ditt telefonnummer har verifierats. Du kan använda det för att logga in nästa gång.",
        t_signup_privacy: "personuppgiftspolicy",
        t_signup_select_city: "Select city",
        t_signup_select_subscription: "Välj medlemskap",
        t_signup_subscription_explain: "Alla biljetter ingår.  Gå på så många evenemang du vill. Ingen bindningstid, säg upp när du vill.",
        t_signup_terms: "användarvillkor",
        t_signup_verify_phone: "Verifiera ditt telefonnummer",
        t_ticket_activates: "Biljett aktiveras $1$",
        t_ticket_booking: "Bokning",
        t_ticket_guestlist: "Gästlista",
        t_ticket_nonrefundable: "Ej återbetalningsbar",
        t_ticket_people: "$1$ personer",
        t_ticket_person: "$1$ person",
        t_ticket_personal: "Bokning låst till $1$",
        t_ticket_row: "Rad $1$",
        t_ticket_seat: "Plats $1$",
        t_video_live_members: "Detta innehåll ingår för medlemmar i Abundo",
        t_video_live_now: "Live just nu",
        t_video_not_active: "Aktivera ditt konto för att ta del av detta innehåll.",
        t_video_not_available: "Detta innehåll är ej längre tillgängligt",
        t_video_remind_confirmation: "Vi skickar en påminnelse till din e-post två timmar innan sändningen startar.",
        t_video_reminder: "Du blir påmind 2 timmar innan start",
        t_video_replay: "Det här är en inspelning från $1$",
        t_video_starts: "Livesändningen startar",
        t_video_until: "Tillgänglig till $1$.",
        td_invite_accepted: "Accepterad",
        td_invite_sent: "Skickat",
        td_payment_failed: "Misslyckad",
        td_payment_giftcard: "Presentkort",
        td_payment_membership: "Medlemskap",
        td_payment_purchase: "Köp",
        td_payment_refund: "Återbetalning",
        td_payment_tickets: "Biljetter",
        td_payment_upgrade: "Uppgradering",
        td_payment_valid_until: "Giltig till",
        terms: "Användarvillkor",
        th_payment_date: "Datum",
        th_payment_description: "Beskrivning",
        th_payment_method: "Betalmetod",
        th_payment_total: "Summa",
        tt_accept_latest: "Acceptera senast",
        tt_book_before: "Boka senast $1$",
        w_cantbook_already: "Du har redan en aktiv bokning till detta evenemang.",
        w_cantbook_been: "Du har redan varit på detta evenemang.\nVi har denna begränsning för att låta alla våra medlemmar få chansen att se våra populära evenemang.",
        w_cantbook_cancel: "Ditt medlemskap är ej längre aktivt vid detta datum. Du kan alltid ångra din uppsägning under \"Mitt konto\"",
        w_cantbook_ended: "Evenemanget har redan ägt rum",
        w_cantbook_expired: "Denna reservation är inte längre tillgänglig",
        w_cantbook_gc: "Ditt medlemskap är ej längre aktivt vid detta datum. Du kan välja att automatiskt starta ett medlemskap när ditt presentkort gått ut under  \"Mitt konto\"",
        w_cantbook_limit: "Du har redan två aktiva bokningar. Du kan genomföra en ny bokning när du har gått på något av evenemangen du redan har inbokade.\nDu kan även boka av en av dina aktiva bokningar för att boka detta evenemang.",
        w_cantbook_loyalty: "Det här evenemanget är bokningsbart för medlemmar som haft aktiva medlemskap de senaste $1$ månaderna. Du har $2$ dagar kvar innan du kan boka det här evenemanget!",
        w_cantbook_loyalty_inactive: "Det här evenemanget är bokningsbart för medlemmar som haft aktiva medlemskap de senaste $1$ månaderna. Ditt konto är inaktivt och du behöver återaktivera ditt konto och hålla det aktivt i $1$ månader för att kunna boka.",
        w_cantbook_notickets: "Inga tillgängliga biljetter",
        w_cantbook_pastdue: "Vi har inte lyckats genomföra betalningen för ditt medlemskap den här månaden. Du måste åtgärda detta för att genomföra en bokning",
        w_cantbook_paused: "Ditt konto är pausat. Återuppta ditt medlemskap under \"Mitt konto\".",
        w_cantbook_sameday: "Du har redan ett evenemang bokat detta datum. Du kan ej ha två aktiva bokningar under samma dag.",
        w_dismiss_rating: "Du kan alltid betygsätta dina tidigare evenemang under \"Mina bokningar\" och fliken \"Tidigare\"",
        w_late_unbook: "Detta är en sen avbokning. Det innebär att du kommer debiteras 100 kr per biljett.",
        w_membership_recovered: "Tack! Din betalning lyckades och du kan nu boka igen",
        w_standby: "Du är nu i standby.",
        w_standby_1: "Du är nu i standby for en biljett.",
        w_standby_2: "Du är nu i standby för två biljetter.",
        w_standby_first: "Detta evenemang är för tillfället fullbokat men chansen är hög att genomföra en bokning. Klicka på \"Standby\" för att få en reservation när fler biljetter blir tillgängliga.",
        w_standby_info: "När vi får fler biljetter tillgängliga kommer vi slumpmässigt reservera biljetter åt medlemmar på standby-listan.",
        w_unbook: "Är du säker på att du vill avboka?",
        w_unbook_one: "Är du säker på att du vill avboka en biljett?",
    },
    ui: {
        back_to: "Tillbaka till",
        button_cancel: "AVBRYT",
        button_delete: "RADERA",
        button_no: "NEJ",
        button_ok: "OK",
        button_save: "SPARA",
        button_send: "SKICKA",
        button_yes: "JA",
        img_drop: "Släpp eller ladda upp bild här",
        inv_email: "Emailadressen är inte giltig",
        inv_number: "Numret är inte inom det godkända intervallet",
        inv_password: "Lösenordet måste innehålla minst 6 tecken",
        inv_required: "Detta fält är obligatoriskt",
        select_dates: "Välj datum",
    },
    y: {
        currency_format: {
            EUR: "$1$ €",
            SEK: "$1$kr",
        },
        days: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
        months: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"],
        short_days: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
        short_months: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    },
};

$i18n_specs['de'] = {
    aa: {
        b_add: "Hinzufügen",
        b_add_pictures: "+ Bilder hinzufügen",
        b_add_recipient: "+ Empfänger hinzufügen",
        b_add_session: "+ Session hinzufügen",
        b_add_tickets: "TICKETS HINZUFÜGEN",
        b_add_user: "User hinzufügen",
        b_booking_list: "BUCHUNGSLISTE",
        b_change: "ÄNDERN",
        b_create_event: "NEUES EVENT ERSTELLEN",
        b_download: "Download",
        b_download_pdf: "Als PDF herunterladen",
        b_duplicate: "DUPLIZIEREN",
        b_edit: "BEARBEITEN",
        b_import: "Importieren",
        b_import_selected: "Ausgewähle Sessions importieren",
        b_missing_info: "Fülle die Details hier aus.",
        b_save_add_dates: "Speichern und Sessions hinzufügen",
        b_save_send: "Spara och skicka för godkännande",
        b_send_booking_list: "Buchungsliste senden an",
        b_session_cancel: "ENTFERNEN",
        b_update: "Aktualisieren",
        c_amount: "Anzahl",
        c_booked: "gebucht",
        c_booking_number: "Buchungsnummer",
        c_date: "Datum",
        c_event: "Veranstaltung",
        c_event_name: "Name",
        c_next_date: "Nächster Termin",
        c_payment_amount: "Anzahl",
        c_period: "Zeitraum",
        c_review: "Bewertung",
        c_standby: "auf Standby",
        c_status: "Status",
        c_ticket_amount: "Anzahl der Tickets",
        c_tickets: "Tickets",
        c_tickets_available: "$1$ Tickets verfügbar",
        c_total: "Betrag",
        c_user_name: "Name",
        f_address: "Anschrift",
        f_choose_venue: "Veranstaltungsort wählen",
        f_city: "Stadt",
        f_company_name: "Firmenname",
        f_date_time: "Datum \u0026 Zeit",
        f_description: "Beschreibe deine Veranstaltung",
        f_dont_feature: "Dieses Event nicht auf der Abundo-Landingpage anzeigen",
        f_dont_feature_sub: "Wir zeigen deine Veranstaltung nur eingeloggten Nutzer:innen",
        f_dont_market: "Diese Veranstaltung nicht außerhalb der Abundo-Plattform bewerben",
        f_dont_market_sub: "Wir werden deine Veranstaltung nicht auf unseren Social Media Kanälen bewerben",
        f_dropin: "Drop-in Session",
        f_duration: "Dauer (in Minuten)",
        f_email: "E-Mail-Adresse",
        f_end_time: "Bis",
        f_event_name: "Benenne deine Veranstaltung",
        f_genre: "Kategorie",
        f_i_instructions: "Hinweise zur Ticketabholung",
        f_i_regular_price: "Trage den regulären Ticketpreis ein",
        f_i_sales_end: "Buchungsstopp festlegen (in Stunden vor Beginn der Veranstaltung)",
        f_i_sales_end_sub: "Wir empfehlen 2 Stunden vor Beginn der Veranstaltung.",
        f_instructions: "Hinweise zur Ticketabholung",
        f_list_recipients: "Empfänger:in der Gästeliste",
        f_media_links: "Medien-Links hinzufügen",
        f_org_number: "Handelsregister",
        f_payout_destination: "Bankverbindung",
        f_permissions: "Berechtigungen",
        f_pictures: "Bilder",
        f_producer: "Veranstalter:in",
        f_regular_price: "Regulärer Preis",
        f_sales_end: "Buchungsstopp (in Stunden vor Beginn des Events)",
        f_ticket_amount: "Anzahl Tickets",
        f_tickets_per_session: "Tickets pro Session",
        f_venue: "Veranstaltungsort",
        h_add_team: "User zu deinem Team hinzufügen",
        h_available_sessions: "VERFÜGBARE SESSIONS",
        m_account: "Account",
        m_handle_events: "Veranstaltungen bearbeiten",
        m_imported: "Importiert",
        m_logout: "Logout",
        m_reviews: "Rezensionen",
        m_sales: "Sales",
        m_summaries: "Berichte",
        m_team: "Team",
        m_upcoming_bookings: "Bevorstehende Buchungen",
        n_bookings: "BUCHUNGEN",
        n_new_event: "NEUES EVENT",
        n_session: "SESSION",
        o_active: "LIVE",
        o_all_events: "All Veranstaltungen",
        o_bookings: "Buchungen",
        o_events: "Veranstaltungen",
        o_invoices: "Berichte",
        o_past: "VERGANGEN",
        o_reviews: "Rezensionen",
        o_tickets: "Tickets",
        o_tickets_sold: "Tickets verkauft",
        o_total_sales: "Verkäufe insgesamt",
        o_users: "Users",
        tb_company_info: "Firmen Informationen",
        tb_date_time: "Datum \u0026 Zeit",
        tb_default_info: "Standard Info",
        tb_event_description: "Eventbeschreibung",
        tb_user_info: "Meine Informationen",
        tt_add_amount: "Anzahl der Abonnenten, die buchen möchten, wenn du weitere Tickets hinzufügst.",
        tt_create_event: "Veranstaltung erstellen",
        tt_edit: "Bearbeiten",
        tt_missing_info: "Bei der Veranstaltung fehlen Informationen",
        tt_publish_pending: "Warte auf Veröffentlichung",
        tt_session_booked: "$1$ gebucht + $2$ reserviert",
        v_paid_on: "Bezahlt $1$",
        v_started: "Begonnen",
        w_cancel_booked: "Es gibt Buchungen für diese Session. Wenn du sie entfernst, werden die Personen, die gebucht haben, automatisch informiert. Bist du sicher, dass du die Session entfernen möchtest?",
        w_missing_info: "Uns fehlen wichtige Unternehmensdaten.",
        w_publish_date: "Dieser Termin wird veröffentlich am $1$",
        w_session_booked: "Die Personen, die diese Show gebucht haben, werden automatisch benachrichtigt, wenn du den Termin änderst. Bist du sicher, dass du den Termin wie folgt ändern möchtest?",
        w_session_booked_new: "Neuer Termin: $1$",
        w_session_booked_previous: "Aktueller Termin: $1$",
    },
    pr: {
        account_account_number: "IBAN",
        account_event_defaults: "Event-Voreinstellungen",
        account_invoice_details: "Rechnungsanschrift",
        account_mobile_title: "Einstellungen",
        account_my_details: "Meine Details",
        account_payment_details: "Zahlungsinformationen",
        account_payment_details_description: "Wohin sollen wir deine Auszahlungen schicken?",
        account_title: "Einstellungen",
        add_tickets_apply: "Änderung anwenden",
        add_tickets_current_amount: "Aktuelle Anzahl: $1$ Tickets",
        add_tickets_placeholder: "Neue Ticketanzahl festlegen",
        add_tickets_title: "Tickets hinzufügen",
        booking_list_mobile_title: "Buchungsliste",
        booking_list_search: "Suche",
        booking_list_send_tickets: "Nach Buchungsstopp, schickst du die Tickets an $1$",
        booking_list_title: "Buchungsliste",
        dashboard_earnings: "Auszahlungen",
        dashboard_last_payment: "Letzte Zahlung",
        dashboard_none: "Keine",
        dashboard_tickets_booked: "gebuchte Tickets",
        dashboard_total: "Gesamt",
        error_invalid_media_link: "Ungültiger Medienlink",
        event_add_link: "Link hinzufügen",
        event_add_media_link: "Media Link hinzufügen",
        event_booking_list: "Buchungsliste",
        event_bookings_ticket: "Ticket $1$",
        event_bookings_unknown_seat: "Unknown seat",
        event_cancel: "Event/Termin absagen",
        event_copy_url: "URL kopieren",
        event_create: "Event erstellen",
        event_create_new_session: "Neue Session erstellen",
        event_duplicate: "Ereignis duplizieren",
        event_edit: "Event bearbeiten",
        event_email_external: "Oder externe E-Mail-Adresse angeben",
        event_email_team: "Teammitglied wählen",
        event_genre: "Genre hinzufügen",
        event_genre_add: "+ Ein weiteres Genre hinzufügen",
        event_link_copied: "Link in die Zwischenablage kopiert",
        event_photo_credits: "Foto Copyright",
        event_save: "Speichern",
        event_send_for_review: "Für Review einreichen",
        event_show: "Event anzeigen",
        events_add_sessions: "Sessions hinzufügen",
        events_add_tickets: "Tickets hinzufügen",
        events_mobile_title: "Events",
        events_more: "+$1$ mehr",
        events_status_draft: "Skizze",
        events_status_imported: "Importiert",
        events_status_live: "Live",
        events_status_past: "Vergangen",
        events_status_sent: "Review\nausstehend",
        events_title: "Events bearbeiten",
        events_tooltip_amount_managed: "Wird über dein reguläres Ticketingsystem verwaltet",
        filter_cities_all: "Alle Städte",
        filter_city: "Stadt",
        filter_date: "Datum",
        filter_event: "Event",
        filter_event_imported: "Importiert",
        filter_event_live: "Live",
        filter_event_previous: "Vergangene Events",
        filter_event_unpublished: "Unveröffentlicht",
        filter_events: "Events",
        filter_events_all: "Alle Events",
        filter_filter: "Filter",
        filter_name: "Name",
        filter_search: "Suche",
        filter_sort: "Sortieren",
        filter_time_period: "Zeitraum",
        filter_venue: "Veranstaltungsort",
        filter_venues_all: "Alle Veranstaltungsorte",
        filter_year: "Jahr",
        filter_year_all: "Alle Jahre",
        menu_account: "Einstellungen",
        menu_dashboard: "Dashboard",
        menu_events: "Events",
        menu_integration: "Integration",
        menu_logged_in_as: "Eingeloggt als",
        menu_new_event: "Neues Event",
        menu_payments: "Zahlungen",
        menu_reviews: "Reviews",
        menu_statistics: "Statistiken",
        menu_team: "Team",
        menu_upcoming: "Buchungen",
        payments_mobile_title: "Auszahlungen: $1$",
        payments_paid: "Ausgezahlt $1$",
        payments_pending: "Auszahlung ausstehend",
        payments_tickets: "$1$ tickets",
        payments_title: "Summe Auszahlungen: $1$",
        reviews_download: "Als PDF herunterladen",
        reviews_mobile_title: "Reviews",
        reviews_search: "Event suchen",
        reviews_send: "Senden an",
        reviews_summary: "Zusammenfassung",
        reviews_title: "Reviews: Alle Events",
        session_booking_stop: "Buchungsstopp einstellen",
        session_create: "Session erstellen",
        session_date: "Datum",
        session_edit_instructions: "Edit instructions",
        session_ticket_type: "Ticket type",
        session_time: "Uhrzeit",
        session_update: "Sitzung aktualisieren",
        sessions_bookings: "$1$ gebucht",
        sessions_col_bookings: "Buchungen",
        sessions_col_closes_at: "Schließt",
        sessions_col_date_time: "Datum und Uhrzeit",
        sessions_col_event: "Event",
        sessions_col_standby: "Standby",
        sessions_col_ticket_type: "Methode",
        sessions_col_venue: "Veranstaltungsort",
        sessions_mobile_title: "Buchungen",
        sessions_more_tickets: "Tickets hinzufügen",
        sessions_open_until: "Offen bis $1$",
        sessions_search: "Sessions durchsuchen",
        sessions_standby: "$1$ standby",
        sessions_title: "Buchungen für bevorstehende Sessions",
        sessions_tooltip_eticket: "Wenn die Buchung um $1$ schließt, schickst du alle Tickets in einem Auftrag aus deinem Ticketsystem an:\nSweden: tickets@abundolive.se\nGermany: tickets@abundolive.de",
        sessions_tooltip_guestlist: "Wenn die Buchung um $1$ schließt, werden die digitale Gästeliste und eine PDF an $2$ gesendet.",
        team_add_member: "Nutzer:in hinzufügen",
        team_admin: "Admin",
        team_admin_description: "Vollzugriff und kann Nutzer:innen hinzufügen/entfernen",
        team_bookings: "Buchungen",
        team_bookings_description: "Buchungen einsehen",
        team_economy: "Zahlungen",
        team_economy_description: "Auszahlungen und Abrechnungen einsehen",
        team_email_address: "E-Mail-Adresse",
        team_events: "Events",
        team_events_description: "Events einsehen, erstellen und bearbeiten",
        team_invite: "Nutzer:in einladen",
        team_invited_users: "Eingeladene Nutzer",
        team_limited_access: "Eingeschränkter Zugang",
        team_mobile_title: "$1$ Team",
        team_remove_confirm: "Bist du sicher, dass du diesen Benutzer entfernen möchtest?",
        team_send_invite: "Einladen",
        team_title: "$1$ Team",
        team_update_permissions: "Berechtigungen aktualisieren",
        ticket_eticket: "E-Ticket",
        ticket_guestlist: "Gästeliste",
    },
    tl: {
        o_filter_dates: {
            range: "Zeitraum",
            today: "Heute",
            tomorrow: "Morgen",
            week: "In dieser Woche",
            weekend: "Dieses Wochenende",
        },
        o_gender: {
            female: "Frau",
            male: "Mann",
            other: "Divers",
        },
        o_giftcard_delivery: {
            digital: "Email",
            post: "Post",
        },
        td_payment_addons: {
            bonus: "Bonus",
            late_cancel: "Stornierungsgebühr",
        },
        about_us: "Über uns",
        b_accept: "Annehmen",
        b_add_standby: "Standby-Ticket hinzufügen",
        b_add_ticket: "Ticket hinzufügen",
        b_all_events: "Alle Events anzeigen",
        b_ap_login: "Mit Apple einloggen",
        b_apply_code: "Code anweden",
        b_back: "Zurück",
        b_back_to_events: "Zurück zu allen Events",
        b_book: "Buchen",
        b_booked: "Gebucht",
        b_buy_more: "Mehr Tickets kaufen",
        b_cancel: "Abbrechen",
        b_change_payment: "Zahlungsmethode ändern",
        b_change_plan: "Mitgliedschaft ändern",
        b_change_pw: "Passwort ändern",
        b_choose: "Wählen",
        b_choose_kind: "Auswählen",
        b_close: "Schließen",
        b_confirm: "Bestätigen",
        b_confirm_booking: "Buchung bestätigen",
        b_continue: "Fortsetzen",
        b_copy_code: "Code kopieren",
        b_copy_link: "Link kopieren",
        b_decline: "Ablehnen",
        b_done: "Fertig",
        b_enter_gc: "Gib den Code ein",
        b_extend_pause: "Pause verlängern",
        b_fb_connect: "Verbinde dich mit Facebook",
        b_fb_continue: "Weiter mit Facebook",
        b_fb_login: "Mit Facebook einloggen",
        b_fill_later: "Später antworten",
        b_filter_clear: "Filter zurücksetzen",
        b_filter_show: "Ergebnisse anzeigen",
        b_forgot: "Passwort vergessen?",
        b_giftcard_confirm_info: "Informationen bestätigen",
        b_giftcard_redeem: "Geschenkkarte einlösen",
        b_have_code: "Hast du einen Code?",
        b_how_it_works: "Wie es funktioniert",
        b_invite_dialog_send: "Einladungen verschicken",
        b_invite_friends_here: "Freund:innen hier einladen.",
        b_invited_resend: "Erneut senden",
        b_leave_comment: "Möchtest du einen Kommentar hinterlassen?",
        b_lets_go: "Los!",
        b_login: "Einloggen",
        b_login_email: "Einloggen mit E-Mail Adresse",
        b_login_email_instead: "Stattdessen mit E-Mail einloggen",
        b_login_phone: "Einloggen mit Telefonnummer",
        b_loyalty_info: "Info",
        b_membership_choose: "Mitgliedschaft auswählen",
        b_membership_resume: "Mitgliedschaft fortsetzen",
        b_more_dates: "Weitere Termine anzeigen",
        b_next: "Weiter",
        b_not_member: "Sie sind noch kein Mitglied? Hier anmelden",
        b_not_now: "Nicht jetzt",
        b_ok: "OK",
        b_pause: "Pause",
        b_pay: "Zahle $1$ $2$",
        b_pay_autogiro: "Autogiro",
        b_pay_autogiro_once: "Direct Bank Transfer with Trustly",
        b_pay_card: "Karte",
        b_payment_receipt: "Rechnung",
        b_read_more: "Mehr lesen",
        b_read_more_abundo: "Lies mehr über Abundo",
        b_renew_subscription: "Mitgliedschaft verlängern",
        b_resend_code: "Code erneut senden",
        b_reserve: "Reservieren",
        b_reset_pw: "Passwort zurücksetzen",
        b_resubscribe_change: "Zahlungsmethode oder Mitgliedschaft ändern",
        b_resume_now: "Jetzt fortsetzen",
        b_save: "Speichern",
        b_see_all: "Alle anzeigen",
        b_see_booking: "Meine Buchung ansehen",
        b_see_event: "Veranstaltung öffnen",
        b_send: "Senden",
        b_send_invites: "Einladungen verschicken",
        b_share: "Teilen",
        b_show_tickets: "Tickets anzeigen",
        b_signup_phone: "Anmelden mit Telefonnummer",
        b_skip: "Überspringen",
        b_standby: "Standby",
        b_standby_remove: "Entferne mich aus der Liste",
        b_start_for: "Start für",
        b_start_watching: "Start watching",
        b_ticket_pdf: "PDF-Ticket öffnen",
        b_to_my_bookings: "Meinen Buchungen anzeigen",
        b_try_again: "Erneut versuchen",
        b_try_month: "Einen Monat lang kostenlos testen",
        b_unbook: "Stornieren",
        b_unbook_one: "1 Ticket entfernen",
        b_undo_cancel: "Stornierung rückgängig machen",
        b_unsubscribe: "Kündigen",
        b_video_account: "Mein konto",
        b_video_buy_amount: "Kaufen für $1$ €",
        b_video_remind: "Erinnere mich",
        b_voucher: "Rabatt-Code?",
        become_member: "Mitglied werden",
        bnr_cancelled: "Deine Mitgliedschaft wurde gekündigt.",
        bnr_cancelled_b: "Nehmen Sie die Mitgliedschaft wieder auf.",
        bnr_none: "Du hast keine aktive Mitgliedschaft.",
        bnr_none_b: "Mitgliedschaft wählen.",
        bnr_pastdue: "Wir konnten keine Zahlung vornehmen.",
        bnr_pastdue_b: "Zahlungsmethode aktualisieren.",
        bnr_paused: "Deine Mitgliedschaft ist unterbrochen.",
        bnr_paused_b: "Nimm deine Mitgliedschaft wieder auf.",
        bnr_pending_cancel: "Deine Mitgliedschaft wird gekündigt.",
        bnr_pending_cancel_b: "Stornierung rückgängig machen.",
        booking_starts: "Beginn",
        cb_notifications_event_info: "Wichtige Informationen zu deinen Buchungen",
        cb_notifications_standby: "Standby-Reservierungen.",
        cb_profile_show_activity: "Anzeigen welche an Events ich teilnehme",
        consent_accept: "Alle Cookies akzeptieren",
        consent_link: "Cookie-Richtlinie",
        consent_preferences: "Cookie-Einstellungen",
        consent_text: "Wir verwenden Cookies und ähnliche Technologien, um Inhalte zu personalisieren, Werbeanzeigen maßzuschneidern und zu messen und ein besseres Erlebnis zu bieten. Wenn Du auf „Alle Cookies akzeptieren“ klickst oder eine Option in den Cookie-Einstellungen aktivierst, erklärst Du dich damit einverstanden, wie in unserer $1$ dargelegt. Wenn Du Deine Präferenzen ändern oder Ihre Zustimmung zurückziehen möchtest, aktualisiere bitte Deine Cookie-Einstellungen.",
        consent_title: "Ihre Privatsphäre",
        e_bookings: "Du hast keine Buchungen.",
        e_invalid_code: "Ungültiger Code",
        events: "Events",
        faq: "Häufig gestellte Fragen",
        for_companies: "Für Unternehmen",
        giftcard_b2b: "Geschenkkarten für Unternehmen",
        h_booking: "Deine Tickets",
        h_booking_confirmation: "Buchung bestätigt",
        h_bookings: "Meine Buchungen",
        h_bookings_current: "BESTÄTIGT",
        h_bookings_past: "VERGANGEN",
        h_bookings_standby: "STANDBY",
        h_cancel_dialog: "Mitgliedschaft kündigen",
        h_card_details: "Kartendetails",
        h_change_plan_dialog: "Wichtige Informationen",
        h_choose_membership: "Mitgliedschaft auswählen",
        h_city: "Stadt auswählen",
        h_create_account: "Benutzerkonto erstellen",
        h_extend_pause: "Pause verlängern",
        h_filter: "Filter",
        h_filter_category: "Kategorie",
        h_filter_city: "Stadt",
        h_filter_date: "Datum",
        h_filter_sort: "Sortieren nach",
        h_forgot: "Passwort vergessen?",
        h_friends: "Freund:innen.",
        h_giftcard_contact: "Deine Kontaktinformationen",
        h_giftcard_delivery: "4. Versandart auswählen",
        h_giftcard_delivery_address: "Lieferadresse",
        h_giftcard_kind: "3. Mitgliedschaft auswählen",
        h_giftcard_kind_2: "2. Mitgliedschaft auswählen",
        h_giftcard_months: "1. Anzahl der Monate auswählen",
        h_giftcard_quantity: "2. Wähle die Anzahl der Geschenkkarten",
        h_instructions: "Anweisungen",
        h_invite_dialog: "Kontakte einladen",
        h_invite_email: "Per E-Mail einladen",
        h_invite_link: "Mit Link einladen",
        h_invite_popup_1: "Teile deinen Link",
        h_invite_popup_2: "Dein Freund bekommt einen gratis Monat",
        h_invite_popup_3: "Du bekommst $1$",
        h_invite_reward: "Jedes Mal, wenn du Freund:innen zu einem Gratismonat einlädst, bekommst du $1$ Rabatt!",
        h_invited: "Eingeladene Freund:innen",
        h_language: "Sprache",
        h_login: "Einloggen",
        h_membership: "Mitgliedschaft",
        h_membership_have_gc: "Hast du eine Geschenkkarte?",
        h_no_commitment: "Keine Vertragsbindung, jederzeit kündbar",
        h_onboarding: "Wir würden dich gerne besser kennenlernen",
        h_onboarding_category: "Deine Favoriten",
        h_onboarding_city: "Deine Stadt",
        h_onboarding_phone: "Deine Telefonnummer",
        h_past: "Vergangene Events",
        h_pause_dialog: "Mitgliedschaft pausieren?",
        h_payment: "Zahlung",
        h_payment_history: "Zahlungshistorie",
        h_profile: "Mein Profil",
        h_profile_favorites: "Meine Favoriten",
        h_profile_pw: "Passwort ändern",
        h_redeem_gc: "Gib den Code ein, der auf der Geschenkkarte steht",
        h_referral_popup: "Einladung von",
        h_reserve_dialog: "Reservieren",
        h_reset_pw: "Passwort zurücksetzen",
        h_resubscribe_dialog: "Mitgliedschaft fortsetzen",
        h_reviews: "Rezensionen",
        h_search: "Suchergebnisse.",
        h_signup: "Mitglieds-Konto erstellen",
        h_signup_confirm_info: "Bestätige deine Angaben",
        h_signup_with_email: "Melde dich mit deiner E-Mail-Adresse an",
        h_standby_first: "Standby",
        h_thanks: "Danke!",
        h_video_not_active: "Dein Konto ist nicht aktiv",
        h_voucher: "Rabatt-Code",
        how_it_works: "Wie Abundo funktioniert",
        invite: "Freund:innen einladen",
        jobs: "Arbeite mit uns",
        l_my_account: "Mein Konto",
        l_read_more_here: "Hier mehr lesen",
        m_bookings: "Meine Buchungen",
        m_friends: "Freunde",
        m_giftcard: "Geschenkkarte",
        m_help_center: "Hilfe",
        m_home: "Start",
        m_login: "Einloggen",
        m_logout: "Ausloggen",
        m_membership: "Mitgliedschaft",
        m_profile: "Mein Profil",
        m_purchases: "Meine Einkäufe",
        m_signup: "Benutzerkonto erstellen",
        more_dates: "+ weitere Termine",
        o_filter_sort_date: "Datum",
        o_filter_sort_recommended: "Empfohlen",
        o_past_3: "Letzten 3 Monate",
        o_past_all: "Alle vergangenen Ereignisse",
        o_tag_all: "Alle",
        p_loyalty: "Diese Veranstaltung kann nur von Mitgliedern gebucht werden, die in den letzten $1$ Monaten eine aktive Mitgliedschaft hatten. Deine Mitgliedschaft war in den letzten $1$ Monaten aktiv, so dass du die Veranstaltung buchen kannst 🎉",
        p_payment_history_bonus: "Wusstest du, dass du für jedes zusätzliche Mitglied 10 € Rabatt bekommst?",
        partners: "Abundo for Partners",
        past: "Vergangene Aufführungen",
        ph_address: "Adresse",
        ph_birth_year: "Geburtsjahr (zB.: 1960)",
        ph_city: "Stadt wählen",
        ph_company_name: "Firma",
        ph_current_pw: "Aktuelles Passwort",
        ph_email: "E-Mail-Adresse",
        ph_first_name: "Vorname",
        ph_gc_amount: "Anzahl Geschenkkarten",
        ph_gc_code: "Code",
        ph_invite_emails: "E-Mail-Adressen eingeben",
        ph_last_name: "Nachname",
        ph_name: "Name",
        ph_new_pw: "Neues Passwort",
        ph_password: "Passwort",
        ph_phone: "Telefonnummer",
        ph_postcity: "Ort.",
        ph_postcode: "Postleitzahl",
        ph_search: "Tippe etwas",
        ph_venue: "Veranstaltungsort auswählen",
        ph_voucher_code: "Code",
        play: "Play",
        press: "Presse",
        privacy: "Datenschutz-Bestimmungen",
        q_onboarding_1: "Wo wirst du hauptsächlich an Veranstaltungen teilnehmen?",
        q_onboarding_2: "An welcher Art von Veranstaltungen bist du interessiert?",
        q_onboarding_3: "Wie lautet deine Telefonnummer?",
        q_onboarding_3m: "Wir benachrichtigen dich, wenn es neue Informationen zu einer Veranstaltung gibt oder wenn sie abgesagt wurde. Du kannst deine SMS-Einstellungen später jederzeit ändern.",
        resubscribe_popup_button: "Mitgliedschaft reaktivieren",
        resubscribe_popup_text: "Reaktiviere die kostenpflichtige Mitgliedschaft um $1$ in Buchung von Events in $2$ zu buchen",
        resubscribe_popup_title: "Willkommen zurück!",
        s_reservation_declined: "Reservierung abgelehnt",
        several_dates: "Mehrere Daten",
        standby_open_until: "Die Standby-Liste ist offen bis",
        t_1_ticket: "1 Ticket",
        t_book_1_extra_ticket: "1 zusätzliches Ticket",
        t_book_accept: "Bei der Buchung akzeptierst du die",
        t_book_conditions: "Buchungsbedingungen",
        t_book_extra_tickets: "zusätzliche Tickets",
        t_book_free_unbook: "gebührenfreie Stornierung bis",
        t_book_no_free_unbook: "Diese Buchung kann nicht gebührenfrei storniert werden.",
        t_book_read_more: "Mehr lesen.",
        t_booking_accept: "Bei der Buchung akzeptierst du die",
        t_booking_amount_1: "$1$ gebuchtes Ticket",
        t_booking_amount_n: "$1$ gebuchte Tickets",
        t_booking_confirmation: "Du kannst dein Ticket auf der Seite \"Meine Buchungen\" finden. Storniere mindestens 24 Stunden vor der Veranstaltung.",
        t_booking_instructions: "Anweisungen",
        t_booking_number: "Buchungsnummer:",
        t_booking_tos: "Buchungsbedingungen",
        t_cancel_dialog_1: "Bei einer Kündigung deaktiviert sich dein Konto am",
        t_cancel_dialog_2: "Alle Buchungen, die du nach diesem Datum hast, werden storniert.",
        t_cancel_dialog_comment: "Bitte hinterlasse einen Kommentar, warum du deine Mitgliedschaft kündigen möchtest. Das wird uns helfen, ein besseres Produkt zu entwickeln!",
        t_cancel_dialog_pause: "Du kannst auch einen weiteren Monat pausieren.",
        t_cancel_dialog_unbook: "Diese Tickets werden storniert",
        t_card_details_why: "Wir brauchen deine Kartendaten, um eine Mitgliedschaft zu beginnen. Es wird keine Transaktion durchgeführt.",
        t_changeplan_downgrade_1: "Die Änderung deiner Mitgliedschaft tritt in Kraft ab dem $1$",
        t_changeplan_downgrade_2: "Danach zahlst du 29 € pro Monat und kannst nur noch ein Ticket pro Veranstaltung buchen. Für alle bestehenden Buchungen nach $1$ wird eines deiner Tickets storniert.",
        t_changeplan_downgrade_3: "Du kannst ein zusätzliches Ticket bis $1$ buchen. Du kannst deine Meinung auch während dieser Zeit ändern.",
        t_changeplan_event_1: "Um zwei Tickets pro Event buchen zu können, musst du deine Mitgliedschaft auf Plus 1 upgraden.",
        t_changeplan_event_2: "Beim Upgrade zahlst du nur die Differenz für die verbleibenden Tage des aktuellen Abrechnungszeitraums und zahlst ab dem nächsten Abrechnungsdatum 55 € pro Monat.",
        t_changeplan_event_3: "Bestätige das Upgrade, indem du die unten stehende Summe bezahlst.",
        t_changeplan_total: "Zu zahlender Betrag:",
        t_changeplan_upgrade_1: "Das Upgrade wird sofort wirksam und du zahlst nur die Differenz für die verbleibenden Tage des bereits bezahlten Zeitraums.",
        t_changeplan_upgrade_2: "Ab dem $1$ zahlst du 55 € pro Monat für deine neue Mitgliedschaft.",
        t_changeplan_upgrade_3: "Bestätige das Upgrade, indem du die unten stehende Summe bezahlst.",
        t_choose_membership: "Buche so viele Veranstaltungen, wie du möchtest. Alle Tickets sind in deiner Mitgliedschaft inklusive. Keine Mindestvertragslaufzeit - du kannst jederzeit kündigen.",
        t_decline_confirmation: "Möchtest du die Reservierung wirklich ablehnen?",
        t_event_duration_h: "Std",
        t_event_duration_m: "Min",
        t_fb_connect: "Verbinde dein Facebook-Konto, um zu sehen, welche Events deine Freund:innen besuchen",
        t_forgot_sent: "Wir haben einen Wiederherstellungslink an die E-Mail-Adresse gesendet",
        t_forgot_spam: "Du kannst die E-Mail nicht finden? Überprüfe deinen Spam-Ordner.",
        t_giftcard_delivery_email: "An deine E-Mail-Adresse verschicken",
        t_giftcard_delivery_post: "Per Post in einem Umschlag an dich, oder and eine Adresse deiner Wahl versenden",
        t_giftcard_discount: "Einschließlich $1$% Rabatt",
        t_giftcard_payment: "Bezahle mit Karte oder Paypal und wir schicken dir die Geschenkkarte zu.",
        t_have_reservation: "Du hast eine Reservierung!",
        t_invite_choose_from: "Kontakte einladen aus",
        t_invite_code: "Dein Einladungscode",
        t_invite_code_info: "Deine Freund:innen können bei der Anmeldung auch deinen persönlichen Code eingeben.",
        t_invite_dialog_choose: "Wähle die Kontakte, die du einladen möchtest.",
        t_invite_email: "Schenke Freund:innen einen Gratismonat mit deinem persönlichen Link.",
        t_invite_or: "oder",
        t_invite_popup_1: "Der obenstehende link ist dein einzigartiger Referral-Code. Damit kannst du ganz einfach Freunde einladen. Teile den link wo du willst - Chat, E-Mail, SMS etc.",
        t_invite_popup_2: "Wer sich über diesen Link anmeldet, bekommt den ersten Monat gratis.",
        t_invite_popup_3: "Für jeden Freund, der zahlendes Abundo-Mitglied wird, erhältst du einen Rabatt von $1$ auf deine nächste Zahlung.",
        t_invited_saved: "So viel hast du gespart",
        t_membership_cancelled: "Deine Mitgliedschaft wurde gekündigt und du kannst noch bis zum $1$ an Veranstaltungen teilnehmen.",
        t_membership_gc: "Deine Geschenkkarte ist gültig bis zum $1$",
        t_membership_next_billing: "Nächste Zahlung:",
        t_membership_none: "Du hast keine aktive Mitgliedschaft",
        t_membership_pastdue: "Die letzte monatliche Zahlung für deine Mitgliedschaft konnte nicht ausgeführt werden. Bitte überprüfe, ob die von dir registrierte Karte gültig ist, nicht für Internetkäufe gesperrt ist, und ob Geld auf dem Konto ist.",
        t_membership_paused: "Deine Mitgliedschaft ist pausiert, und wird fortgesetzt am $1$",
        t_membership_pauses: "Ihre Mitgliedschaft wird pausiert $1$",
        t_more_events_bottom: "Konzerte, Theater, Oper, Tanz, Stand-up, Kunstausstellungen, Filme und mehr. Es werden täglich neue Events hinzugefügt.",
        t_more_events_count: "+ $1$ Event",
        t_n_tickets: "Tickets",
        t_newsletter_thanks_city: "Vielen Dank! Wir informieren dich über spannende Veranstaltungen in",
        t_onboarding: "Damit wir dich besser kennenlernen können, möchten wir dir drei kurze Fragen stellen. Du kannst deine Antworten in deinen Einstellungen jederzeit ändern.",
        t_onboarding_category: "Sag uns was dir gefällt, damit wir dir bessere Empfehlungen geben können!",
        t_onboarding_city: "In welcher Stadt wirst du hauptsächlich Veranstaltungen besuchen?",
        t_onboarding_phone_1: "Wir benachrichtigen dich, wenn eine von dir gebuchte Veranstaltung abgesagt oder verschoben wird.",
        t_onboarding_phone_2: "Du kannst deine Benachrichtigungs-Einstellungen jederzeit ändern.",
        t_past: "Eine Auswahl and Abundo-Events aus dem letzten Jahr",
        t_past_archived_1: "Dies ist eine archivierte Veranstaltung.",
        t_past_archived_2: "Aber wir haben momentan Hunderte aktive Veranstaltungen,",
        t_past_archived_3: "von denen wir wissen, dass sie dir gefallen werden!",
        t_pastdue_unbook_warning: "Achtung! Diese Buchung kann automatisch storniert werden. Hier mehr lesen",
        t_pause_choose_months: "Wähle die Anzahl der Monate",
        t_pause_dialog: "Du behältst deinen Account, und nach der Pause wird die Mitgliedschaft automatisch fortgesetzt. Während des pausierten Zeitraums zahlst du keine Mitgliedsbeiträge.",
        t_pause_dialog_unsubscribe: "Nein, danke, ich möchte meine Mitgliedschaft kündigen",
        t_ppv_confirmation_1: "Du findest deine gekauften Inhalte immer unter \"Meine Einkäufe\" im Menü.",
        t_ppv_confirmation_2: "Zahlungsbeleg wurde gesendet an",
        t_ppv_confirmation_3: "Willkommen bei Abundo!",
        t_profile_favorites: "Nenne uns deine Lieblingskategorien, damit wir dir personalisierte Tipps geben können!",
        t_profile_name: "Kontaktiere uns, wenn du deinen Namen ändern möchtest.",
        t_profile_show_activity: "Wähle aus, ob deine Freund:innen sehen können welche Events du gebucht hast.",
        t_promo_code: "Gib deinen Code",
        t_rate_event: "Wie war",
        t_referral_popup_1: "ist ein Mitglied von Abundo, und lädt dich zu einem kostenlosen Test-Monat ein. Melde dich unten an!",
        t_referral_popup_2: "Abundo ist ein Abo für Hunderte Events in Berlin.",
        t_referral_popup_3: "Keine Vertragsbindung, jederzeit kündbar",
        t_reserve_dialog: "Gib die E-Mail-Adressen der Freund:innen ein, für die du Tickets reservieren möchtest. Die Reservierung wird für drei Stunden aufbewahrt und deine Freund:innen erhalten eine E-Mail und eine Reservierung im Bereich \"Standby\" unter \"Meine Buchungen\".",
        t_reset_pw: "Gib ein neues Passwort ein",
        t_resubscribe_dialog: "Bei der Aktivierung belasten wir deine Karte $1$ mit $2$",
        t_review_see_more: "Mehr lesen",
        t_reviews: "Rezensionen",
        t_signup_accept: "Wenn du mit deiner Anmeldung fortfährst, akzeptierst du unsere $1$ und unsere $2$.",
        t_signup_already: "Du hast bereits ein Konto?",
        t_signup_ask_city: "Wo befindest du dich?",
        t_signup_ask_email: "Bitte nenne uns deine E-Mail Adresse.",
        t_signup_ask_name: "Bitte nenne uns deinen Namen.",
        t_signup_confirm_email: "Bestätige oder aktualisiere deine E-Mail Adresse",
        t_signup_confirm_name: "Bestätige oder aktualisiere deinen Namen",
        t_signup_dont_activate_text: "Ihre Kreditkarte wird nicht belastet. Wir brauchen Ihre Kreditkartendaten nur für verspätete Event Absagen oder bei Nichterscheinen zu einem gebuchten Event.",
        t_signup_email_already: "Diese E-Mail ist bereits registriert.",
        t_signup_email_password: "Bitte gib dein Passwort ein, um dich bei deinem bestehenden Konto anzumelden.",
        t_signup_enter_email_code: "Bitte gib den 6-stelligen Code ein, der dir per E-Mail zugeschickt wurde.",
        t_signup_enter_phone: "Bitte nenne uns deine Mobilfunknummer",
        t_signup_enter_phone_code: "Bitte gib den 6-stelligen Code ein, den du erhalten hast.",
        t_signup_gender_age: "Geschlecht und Alter",
        t_signup_name_why: "Bei manchen Veranstaltungen wirst du von uns auf die Gästeliste gesetzt. Achte darauf, dass dein Name mit dem Namen auf deinem Ausweis übereinstimmt.",
        t_signup_or: "oder",
        t_signup_phone_verified: "Deine Telefonnummer ist nun verifiziert. Du kannst dich beim nächsten Mal damit anmelden.",
        t_signup_privacy: "Datenschutzvereinbarung.",
        t_signup_select_city: "Select city",
        t_signup_select_subscription: "Mitgliedschaft auswählen",
        t_signup_subscription_explain: "Alle Tickets inklusive. Geh zu so vielen Veranstaltungen, wie du willst. Jederzeit kündbar.",
        t_signup_terms: "Nutzungsbedingungen",
        t_signup_verify_phone: "Verifiziere deine Telefonnummer.",
        t_ticket_activates: "Ticket aktiviert: $1$",
        t_ticket_booking: "Booking",
        t_ticket_guestlist: "Gästeliste",
        t_ticket_nonrefundable: "Non refundable",
        t_ticket_people: "$1$ Personen",
        t_ticket_person: "$1$ Person",
        t_ticket_personal: "Personalisiertes Ticket: $1$",
        t_ticket_row: "Reihe $1$",
        t_ticket_seat: "Sitz $1$",
        t_video_live_members: "Dieser Inhalt ist nur für Abundo-Mitglieder verfügbar",
        t_video_live_now: "Jetzt live",
        t_video_not_active: "Aktiviere dein Konto, um diesen Inhalt zu nutzen.",
        t_video_not_available: "Dieser Inhalt ist nicht mehr verfügbar",
        t_video_remind_confirmation: "Wir werden zwei Stunden vor dem Stream eine Erinnerung an deine E-Mail-Adresse senden.",
        t_video_reminder: "Sie werden 2 Stunden vor dem Start daran erinnert",
        t_video_replay: "Dies ist ein Live-Stream vom $1$",
        t_video_starts: "Der Livestream beginnt",
        t_video_until: "Erhältlich für $1$.",
        td_invite_accepted: "Akzeptiert",
        td_invite_sent: "Gesendet.",
        td_payment_failed: "Fehlgeschlagen",
        td_payment_giftcard: "Geschenkgutschein",
        td_payment_membership: "Mitgliedschaft",
        td_payment_purchase: "Kaufen",
        td_payment_refund: "Erstattung",
        td_payment_tickets: "Tickets",
        td_payment_upgrade: "Upgrade",
        td_payment_valid_until: "Gültig bis",
        terms: "Nutzungsbedingungen",
        th_payment_date: "Datum",
        th_payment_description: "Beschreibung",
        th_payment_method: "Zahlungsmethode.",
        th_payment_total: "Betrag",
        tt_accept_latest: "Spätestens akzeptieren bis",
        tt_book_before: "Buche spätestens bis $1$",
        w_cantbook_already: "Du hast bereits eine aktive Buchung für diese Veranstaltung.",
        w_cantbook_been: "Du warst bereits bei dieser Veranstaltung.",
        w_cantbook_cancel: "Deine Mitgliedschaft ist ab dem Datum der Veranstaltung nicht mehr aktiv. Du kannst deine Mitgliedschaft unter \"Mitgliedschaft\" fortsetzen.",
        w_cantbook_ended: "Die Veranstaltung hat bereits stattgefunden",
        w_cantbook_expired: "Diese Reservierung ist nicht mehr verfügbar",
        w_cantbook_gc: "Deine Mitgliedschaft ist am Tag der Veranstaltung nicht mehr aktiv. Du kannst unter \"Mitgliedschaft\" automatisch eine Mitgliedschaft beginnen, wenn deine Geschenkkarte abläuft.",
        w_cantbook_limit: "Du hast bereits zwei aktive Buchungen. Du kannst eine neue Buchung vornehmen, nachdem du eine der Veranstaltungen besucht hast oder wenn du eine deiner aktiven Buchungen stornierst.",
        w_cantbook_loyalty: "Diese Veranstaltung kann nur von Mitgliedern gebucht werden, die in den letzten $1$ Monaten eine aktive Mitgliedschaft hatten. In $2$ Tagen kannst du diese Veranstaltung buchen!",
        w_cantbook_loyalty_inactive: "Diese Veranstaltung kann nur von Mitgliedern gebucht werden, die in den letzten $1$ Monaten eine aktive Mitgliedschaft hatten. Deine Mitgliedschaft ist inaktiv und pausiert. Um dich anzumelden, musst du deine Mitgliedschaft reaktivieren und für $1$ aufeinanderfolgende Monate aktiv halten.",
        w_cantbook_notickets: "Keine Tickets verfügbar.",
        w_cantbook_pastdue: "Wir konnten die letzte monatliche Zahlung für deine Mitgliedschaft nicht durchführen. Bis die Zahlung registriert ist, kannst du keine Events buchen",
        w_cantbook_paused: "Ihr Konto wurde pausiert. Setzen Sie Ihre Mitgliedschaft unter \"Mitgliedschaft\" fort.",
        w_cantbook_sameday: "Du hast bereits eine Veranstaltung für diesen Termin gebucht. Du kannst nicht zwei aktive Buchungen am selben Tag haben.",
        w_dismiss_rating: "Du kannst besuchte Veranstaltungen jederzeit unter \"Meine Buchungen\" bewerten",
        w_late_unbook: "Dies ist eine kurzfristige Stornierung. Das bedeutet, dass pro Ticket 10 € Stornogebühren anfallen.",
        w_membership_recovered: "Vielen Dank! Deine Zahlung war erfolgreich und du kannst jetzt wieder buchen",
        w_standby: "Du stehst jetzt auf der Standby-Liste.",
        w_standby_1: "Du stehst jetzt auf Standby für 1 Ticket.",
        w_standby_2: "Du stehst jetzt auf Standby für 2 Tickets.",
        w_standby_first: "Diese Veranstaltung ist momentan ausgebucht, aber vielleicht gibt es bald die Möglichkeit noch Tickets zu bekommen. Klicke auf \"Standby\", um eine Reservierung zu erhalten, falls weitere Tickets verfügbar werden.",
        w_standby_info: "Sobald mehr Tickets verfügbar sind, reservieren wir nach dem Zufallsprinzip Tickets für Mitglieder auf der Standby-Liste.",
        w_unbook: "Bist du sicher, dass du deine Buchung stornieren möchtest?",
        w_unbook_one: "Möchten Sie ein Ticket wirklich stornieren?",
    },
    ui: {
        back_to: "Zurück zu",
        button_cancel: "ABBRECHEN",
        button_delete: "LÖSCHEN",
        button_no: "NEIN",
        button_ok: "OK",
        button_save: "SPEICHERN",
        button_send: "SENDEN",
        button_yes: "JA",
        img_drop: "Bild hier einfügen oder hochladen",
        inv_email: "Die E-Mail-adresse ist nicht gültig",
        inv_number: "Die Nummer liegt nicht im zugelassenen Bereich",
        inv_password: "Das Passwort muss mindestens 6 Zeichen enthalten",
        inv_required: "Das Feld ist ein Pflichtfeld",
        select_dates: "Daten auswählen",
    },
    y: {
        currency_format: {
            EUR: "$1$ €",
            SEK: "$1$ kr",
        },
        days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "December"],
        short_days: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        short_months: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
    },
};

$i18n_specs['es'] = {
    aa: {
        b_add: "Add",
        b_add_pictures: "+ Add more pictures",
        b_add_recipient: "+ Add more recipients",
        b_add_session: "+ Add session",
        b_add_tickets: "ADD TICKETS",
        b_add_user: "ADD USER",
        b_booking_list: "BOOKING LIST",
        b_change: "CHANGE",
        b_create_event: "CREATE NEW EVENT",
        b_download: "Download",
        b_download_pdf: "Download as PDF",
        b_duplicate: "DUPLICATE",
        b_edit: "EDIT",
        b_import: "Import",
        b_import_selected: "Import selected sessions",
        b_missing_info: "Fill in the details here.",
        b_save_add_dates: "Save and add dates",
        b_save_send: "Save and send for approval",
        b_send_booking_list: "Send booking list to",
        b_session_cancel: "REMOVE",
        b_update: "Update",
        c_amount: "Amount",
        c_booked: "booked",
        c_booking_number: "Booking number",
        c_date: "Date",
        c_event: "Event",
        c_event_name: "Name",
        c_next_date: "Next date",
        c_payment_amount: "Amount",
        c_period: "Period",
        c_review: "Review",
        c_standby: "on standby",
        c_status: "Status",
        c_ticket_amount: "Number of tickets",
        c_tickets: "Tickets",
        c_tickets_available: "$1$ tickets available",
        c_total: "Total",
        c_user_name: "Name",
        f_address: "Address",
        f_choose_venue: "Choose venue",
        f_city: "City",
        f_company_name: "Company name",
        f_date_time: "Time \u0026 Date",
        f_description: "Describe your event",
        f_dont_feature: "Do not feature this event on the public Abundo website",
        f_dont_feature_sub: "We will only show your event to logged in users",
        f_dont_market: "Do not market this event outside of the Abundo platform",
        f_dont_market_sub: "We will not share your event on our social media channels",
        f_dropin: "Drop-in session",
        f_duration: "Set event length (minutes)",
        f_email: "E-mail address",
        f_end_time: "To",
        f_event_name: "Name your event",
        f_genre: "Genre",
        f_i_instructions: "Describe ticket collection instructions",
        f_i_regular_price: "Enter the events regular ticket price",
        f_i_sales_end: "Set booking stop (hours before the event starts)",
        f_i_sales_end_sub: "We recommend 2 hours before the event starts.",
        f_instructions: "Ticket collection instruction",
        f_list_recipients: "Guest list recipient",
        f_media_links: "Add media links",
        f_org_number: "Organization Number",
        f_payout_destination: "Account for payout",
        f_permissions: "Permissions",
        f_pictures: "Pictures",
        f_producer: "Producer",
        f_regular_price: "Regular ticket price",
        f_sales_end: "Booking stop (hours before starting)",
        f_ticket_amount: "Number of tickets",
        f_tickets_per_session: "Tickets per session",
        f_venue: "Venue",
        h_add_team: "Add a user to your team",
        h_available_sessions: "AVAILABLE SESSIONS",
        m_account: "Account",
        m_handle_events: "Manage events",
        m_imported: "Imported",
        m_logout: "Logout",
        m_reviews: "Reviews",
        m_sales: "Sales",
        m_summaries: "Summaries",
        m_team: "Team",
        m_upcoming_bookings: "Upcoming bookings",
        n_bookings: "BOOKINGS",
        n_new_event: "NEW EVENT",
        n_session: "SESSION",
        o_active: "LIVE",
        o_all_events: "All events",
        o_bookings: "bookings",
        o_events: "events",
        o_invoices: "invoices",
        o_past: "EARLIER",
        o_reviews: "reviews",
        o_tickets: "tickets",
        o_tickets_sold: "tickets sold",
        o_total_sales: "total sales",
        o_users: "users",
        tb_company_info: "Company information",
        tb_date_time: "Date \u0026 Time",
        tb_default_info: "Standard info",
        tb_event_description: "Event description",
        tb_user_info: "My information",
        tt_add_amount: "Number of subscribers that would like to book if you add more tickets.",
        tt_create_event: "Create event",
        tt_edit: "Edit",
        tt_missing_info: "The event is missing information",
        tt_publish_pending: "Waiting for publication",
        tt_session_booked: "$1$ booked + $2$ reserved",
        v_paid_on: "Paid $1$",
        v_started: "Started",
        w_cancel_booked: "There are bookings for this show. If you remove it the people who have booked will be automatically informed. Are you sure you wish to remove the showing?",
        w_missing_info: "We are missing important company details.",
        w_publish_date: "This date will be published $1$",
        w_session_booked: "There are bookings for this scheduled playing time. The people who have booked this show will automatically be notified if you change the If you change the scheduled playing time. Are you sure you want to change the scheduled playing time to the following?",
        w_session_booked_new: "New time: $1$",
        w_session_booked_previous: "Earlier time: $1$",
    },
    pr: {
        account_account_number: "Account number",
        account_event_defaults: "Event defaults",
        account_invoice_details: "Invoice details",
        account_mobile_title: "Settings",
        account_my_details: "My details",
        account_payment_details: "Invoice details",
        account_payment_details_description: "Where should we submit your payments?",
        account_title: "Settings",
        add_tickets_apply: "Apply change",
        add_tickets_current_amount: "Current amount: $1$ tickets",
        add_tickets_placeholder: "Set new ticket amount",
        add_tickets_title: "Add tickets to session",
        booking_list_mobile_title: "Booking list",
        booking_list_search: "Search",
        booking_list_send_tickets: "When booking is closed you send the booked amount to $1$",
        booking_list_title: "Booking list",
        dashboard_earnings: "Payouts",
        dashboard_last_payment: "Last payout",
        dashboard_none: "None",
        dashboard_tickets_booked: "Tickets booked",
        dashboard_total: "Total",
        error_invalid_media_link: "Invalid media link",
        event_add_link: "Add link",
        event_add_media_link: "Add media link",
        event_booking_list: "Booking list",
        event_bookings_ticket: "Ticket $1$",
        event_bookings_unknown_seat: "Unknown seat",
        event_cancel: "Cancel event",
        event_copy_url: "Copy URL",
        event_create: "Create event",
        event_create_new_session: "Create new session",
        event_duplicate: "Duplicate event",
        event_edit: "Edit event",
        event_email_external: "Or submit external email address",
        event_email_team: "Choose team member",
        event_genre: "Enter genre",
        event_genre_add: "+ Add another genre",
        event_link_copied: "Link copied to clipboard",
        event_photo_credits: "Photo credits",
        event_save: "Save",
        event_send_for_review: "Send for review",
        event_show: "Show event",
        events_add_sessions: "Add sessions",
        events_add_tickets: "Add tickets",
        events_mobile_title: "Events",
        events_more: "+$1$ more",
        events_status_draft: "Draft",
        events_status_imported: "Imported",
        events_status_live: "Live",
        events_status_past: "Past",
        events_status_sent: "Review pending",
        events_title: "Edit events",
        events_tooltip_amount_managed: "Managed through your regular ticketing system",
        filter_cities_all: "All cities",
        filter_city: "City",
        filter_date: "Date",
        filter_event: "Event",
        filter_event_imported: "Imported",
        filter_event_live: "Live",
        filter_event_previous: "Previous",
        filter_event_unpublished: "Unpublished",
        filter_events: "Events",
        filter_events_all: "All events",
        filter_filter: "Filter",
        filter_name: "Name",
        filter_search: "Search",
        filter_sort: "Sort",
        filter_time_period: "Time period",
        filter_venue: "Venue",
        filter_venues_all: "All venues",
        filter_year: "Year",
        filter_year_all: "All years",
        menu_account: "Settings",
        menu_dashboard: "Dashboard",
        menu_events: "Events",
        menu_integration: "Integration",
        menu_logged_in_as: "Logged in as",
        menu_new_event: "New event",
        menu_payments: "Payments",
        menu_reviews: "Reviews",
        menu_statistics: "Statistics",
        menu_team: "Team",
        menu_upcoming: "Bookings",
        payments_mobile_title: "Payouts: $1$",
        payments_paid: "Paid $1$",
        payments_pending: "Payout pending",
        payments_tickets: "$1$ tickets",
        payments_title: "Total payouts: $1$",
        reviews_download: "Download as PDF",
        reviews_mobile_title: "Reviews",
        reviews_search: "Search events",
        reviews_send: "Send",
        reviews_summary: "Summary",
        reviews_title: "Reviews: All events",
        session_booking_stop: "Set booking stop",
        session_create: "Create session",
        session_date: "Date",
        session_edit_instructions: "Edit instructions",
        session_ticket_type: "Ticket type",
        session_time: "Time",
        session_update: "Update session",
        sessions_bookings: "$1$ booked",
        sessions_col_bookings: "Bookings",
        sessions_col_closes_at: "Closes at",
        sessions_col_date_time: "Date and time",
        sessions_col_event: "Event",
        sessions_col_standby: "Standby",
        sessions_col_ticket_type: "Method",
        sessions_col_venue: "Venue",
        sessions_mobile_title: "Bookings",
        sessions_more_tickets: "Add tickets",
        sessions_open_until: "Open until $1$",
        sessions_search: "Search sessions",
        sessions_standby: "$1$ standby",
        sessions_title: "Bookings for upcoming sessions",
        sessions_tooltip_eticket: "When booking closes at $1$, send the total booked amount in one order from your ticketing system to:\nSweden: tickets@abundolive.se\nGermany: tickets@abundolive.de",
        sessions_tooltip_guestlist: "When booking closes at $1$, a digital guest list and PDF are sent to $2$.",
        team_add_member: "Add user",
        team_admin: "Admin",
        team_admin_description: "Full access and can add and remove users",
        team_bookings: "Bookings",
        team_bookings_description: "View Bookings",
        team_economy: "Payouts",
        team_economy_description: "View payouts and invoices",
        team_email_address: "Email address",
        team_events: "Events",
        team_events_description: "View, create and edit events",
        team_invite: "Invite user",
        team_invited_users: "Invited users",
        team_limited_access: "Limited access",
        team_mobile_title: "$1$ team",
        team_remove_confirm: "Are you sure you want to remove this user?",
        team_send_invite: "Send invite",
        team_title: "$1$ team",
        team_update_permissions: "Update permissions",
        ticket_eticket: "E-ticket",
        ticket_guestlist: "Guestlist",
    },
    tl: {
        o_filter_dates: {
            range: "Date range",
            today: "Today",
            tomorrow: "Tomorrow",
            week: "This week",
            weekend: "This weekend",
        },
        o_gender: {
            female: "Female",
            male: "Male",
            other: "Other",
        },
        o_giftcard_delivery: {
            digital: "Email",
            post: "Mail",
        },
        td_payment_addons: {
            bonus: "Bonus",
            late_cancel: "Cancelation Fee",
        },
        about_us: "About us",
        b_accept: "Accept",
        b_add_standby: "Add standby ticket",
        b_add_ticket: "Add ticket",
        b_all_events: "See all events",
        b_ap_login: "Log in with Apple",
        b_apply_code: "Apply code",
        b_back: "Back",
        b_back_to_events: "Back to all events",
        b_book: "Book",
        b_booked: "Booked",
        b_buy_more: "Buy more tickets",
        b_cancel: "Cancel",
        b_change_payment: "Change payment method",
        b_change_plan: "Change membership",
        b_change_pw: "Change password",
        b_choose: "Choose",
        b_choose_kind: "Select",
        b_close: "Close",
        b_confirm: "Confirm",
        b_confirm_booking: "Confirm booking",
        b_continue: "Continue",
        b_copy_code: "Copy code",
        b_copy_link: "Copy link",
        b_decline: "Decline",
        b_done: "Done",
        b_enter_gc: "Enter the code",
        b_extend_pause: "Extend pause",
        b_fb_connect: "Connect to Facebook",
        b_fb_continue: "Continue with Facebook",
        b_fb_login: "Log in with Facebook",
        b_fill_later: "Answer later",
        b_filter_clear: "Clear filter",
        b_filter_show: "Show results",
        b_forgot: "Forgot password?",
        b_giftcard_confirm_info: "Confirm details",
        b_giftcard_redeem: "Redeem gift card",
        b_have_code: "Do you have a code?",
        b_how_it_works: "How it works",
        b_invite_dialog_send: "Send invites",
        b_invite_friends_here: "Invite friends here.",
        b_invited_resend: "Send again",
        b_leave_comment: "Do you want to leave a comment?",
        b_lets_go: "Go!",
        b_login: "Log in",
        b_login_email: "Log in with email",
        b_login_email_instead: "Log in via email instead",
        b_login_phone: "Log in with phone number",
        b_loyalty_info: "Info",
        b_membership_choose: "Select subscription",
        b_membership_resume: "Resume membership",
        b_more_dates: "Show more dates",
        b_next: "Next",
        b_not_member: "Not a member? Sign up here",
        b_not_now: "Not now",
        b_ok: "OK",
        b_pause: "Pause",
        b_pay: "Pay $2$ $1$",
        b_pay_autogiro: "Autogiro",
        b_pay_autogiro_once: "Direct Bank Transfer with Trustly",
        b_pay_card: "Card",
        b_payment_receipt: "Receipt",
        b_read_more: "Read more",
        b_read_more_abundo: "Read more about Abundo",
        b_renew_subscription: "Extend membership",
        b_resend_code: "Resend code",
        b_reserve: "Reserve",
        b_reset_pw: "Reset password",
        b_resubscribe_change: "Change payment method or membership",
        b_resume_now: "Resume now",
        b_save: "Save",
        b_see_all: "See all",
        b_see_booking: "See my booking",
        b_see_event: "See event",
        b_send: "Send",
        b_send_invites: "Send invites",
        b_share: "Share",
        b_show_tickets: "Show tickets",
        b_signup_phone: "Sign up with phone number",
        b_skip: "Skip",
        b_standby: "Standby",
        b_standby_remove: "Remove yourself from the list",
        b_start_for: "Start for",
        b_start_watching: "Start watching",
        b_ticket_pdf: "Open PDF ticket",
        b_to_my_bookings: "See my bookings",
        b_try_again: "Try again",
        b_try_month: "Try a free month",
        b_unbook: "Unbook",
        b_unbook_one: "Cancel one ticket",
        b_undo_cancel: "Undo cancellation",
        b_unsubscribe: "Unsubscribe",
        b_video_account: "My account",
        b_video_buy_amount: "Buy access for SEK $1$",
        b_video_remind: "Remind me",
        b_voucher: "Voucher?",
        become_member: "Become a member",
        bnr_cancelled: "Your membership is canceled.",
        bnr_cancelled_b: "Resume membership.",
        bnr_none: "You have no active membership.",
        bnr_none_b: "Choose membership.",
        bnr_pastdue: "We were unable to make a payment.",
        bnr_pastdue_b: "Update payment.",
        bnr_paused: "Your membership is suspended.",
        bnr_paused_b: "Resume your membership.",
        bnr_pending_cancel: "Your membership will be canceled.",
        bnr_pending_cancel_b: "Undo cancellation.",
        booking_starts: "Starts",
        cb_notifications_event_info: "Important information about your bookings",
        cb_notifications_standby: "Standby reservations",
        cb_profile_show_activity: "Show what I'm going to",
        consent_accept: "Accept all cookies",
        consent_link: "Cookie Policy",
        consent_preferences: "Cookie settings",
        consent_text: "We use cookies and similar technologies to personalize content, tailor and measure ads and provide a better experience. By clicking Accept all cookies or turning on an option in Cookie Settings, you agree to this as set out in our $1$. To change your preferences or withdraw your consent, please update your Cookie Settings.",
        consent_title: "Your privacy",
        e_bookings: "You have no bookings.",
        e_invalid_code: "Invalid code",
        events: "Events",
        faq: "FAQ",
        for_companies: "For Companies",
        giftcard_b2b: "Gift cards for businesses",
        h_booking: "Your tickets",
        h_booking_confirmation: "Booking confirmed",
        h_bookings: "My bookings",
        h_bookings_current: "CURRENT",
        h_bookings_past: "PREVIOUS",
        h_bookings_standby: "STANDBY",
        h_cancel_dialog: "Cancel membership",
        h_card_details: "Card details",
        h_change_plan_dialog: "Important information",
        h_choose_membership: "Select subscription",
        h_city: "City",
        h_create_account: "Create account",
        h_extend_pause: "Extend pause",
        h_filter: "Filter",
        h_filter_category: "Category",
        h_filter_city: "City",
        h_filter_date: "Date",
        h_filter_sort: "Sort by",
        h_forgot: "Forgot password?",
        h_friends: "Friends",
        h_giftcard_contact: "Your contact details",
        h_giftcard_delivery: "4. Choose delivery method",
        h_giftcard_delivery_address: "Delivery address",
        h_giftcard_kind: "3. Select subscription",
        h_giftcard_kind_2: "2. Select subscription",
        h_giftcard_months: "1. Choose number of months",
        h_giftcard_quantity: "2. Select the number of gift cards",
        h_instructions: "Instructions",
        h_invite_dialog: "Invite contacts",
        h_invite_email: "Invite by email",
        h_invite_link: "Invite by link",
        h_invite_popup_1: "Share your link",
        h_invite_popup_2: "Your friend gets one month free",
        h_invite_popup_3: "You get $1$",
        h_invite_reward: "You get $1$ every time you invite a friend to a free month!",
        h_invited: "Invited friends",
        h_language: "Language",
        h_login: "Log in",
        h_membership: "Membership",
        h_membership_have_gc: "Do you have a gift card?",
        h_no_commitment: "No commitment, cancel whenever you want",
        h_onboarding: "We'd like to get to know you better",
        h_onboarding_category: "Your favorites",
        h_onboarding_city: "Your city",
        h_onboarding_phone: "Your phone number?",
        h_past: "Past events",
        h_pause_dialog: "Pause your subscription?",
        h_payment: "Payment",
        h_payment_history: "Payment history",
        h_profile: "My personal details",
        h_profile_favorites: "My favorites",
        h_profile_pw: "Change password",
        h_redeem_gc: "Enter the code found on the gift card",
        h_referral_popup: "Invite from",
        h_reserve_dialog: "Reserve",
        h_reset_pw: "Reset password",
        h_resubscribe_dialog: "Resume membership",
        h_reviews: "Reviews",
        h_search: "Search results for",
        h_signup: "Create account",
        h_signup_confirm_info: "Confirm your information",
        h_signup_with_email: "Register with your email address",
        h_standby_first: "Standby",
        h_thanks: "Thank you!",
        h_video_not_active: "Your account is not active",
        h_voucher: "Voucher",
        how_it_works: "How Abundo works",
        invite: "Invite friends",
        jobs: "Work with us",
        l_my_account: "My account",
        l_read_more_here: "Read more",
        m_bookings: "My bookings",
        m_friends: "Friends",
        m_giftcard: "Gift cards",
        m_help_center: "Help center",
        m_home: "Home",
        m_login: "Log in",
        m_logout: "Sign out",
        m_membership: "Membership",
        m_profile: "My profile",
        m_purchases: "My purchases",
        m_signup: "Sign up",
        more_dates: "+ more dates",
        o_filter_sort_date: "Date",
        o_filter_sort_recommended: "Recommended",
        o_past_3: "Last 3 months",
        o_past_all: "All past events",
        o_tag_all: "All",
        p_loyalty: "This event is bookable for members who have had active memberships during the past $1$ months. Your membership has been active during the past $1$ months and you can therefore book 🎉",
        p_payment_history_bonus: "Do you know you get 100 kr for each member you refer?",
        partners: "Abundo for Partners",
        past: "Past events",
        ph_address: "Street",
        ph_birth_year: "Birth year (write full year, ex. 1960)",
        ph_city: "Choose city",
        ph_company_name: "Company name",
        ph_current_pw: "Current password",
        ph_email: "Email address",
        ph_first_name: "First name",
        ph_gc_amount: "Amount of gift cards",
        ph_gc_code: "Code",
        ph_invite_emails: "Enter email addresses",
        ph_last_name: "Last name",
        ph_name: "Name",
        ph_new_pw: "New password",
        ph_password: "Password",
        ph_phone: "Phone number",
        ph_postcity: "City",
        ph_postcode: "Post code",
        ph_search: "Type something",
        ph_venue: "Choose venue",
        ph_voucher_code: "Voucher code",
        play: "Play",
        press: "Press",
        privacy: "Privacy policy",
        q_onboarding_1: "Where are you mainly going to attend events?",
        q_onboarding_2: "What type of events are you interested in?",
        q_onboarding_3: "What is your phone number?",
        q_onboarding_3m: "We'll let you know when there is new information about an event or if it is cancelled. You can always change your SMS-settings later.",
        resubscribe_popup_button: "Activate",
        resubscribe_popup_text: "Restart your paid membership to book $1$ events in $2$",
        resubscribe_popup_title: "Welcome back!",
        s_reservation_declined: "Reservation declined",
        several_dates: "Multiple dates",
        standby_open_until: "The standby list is open until",
        t_1_ticket: "1 ticket",
        t_book_1_extra_ticket: "1 extra ticket",
        t_book_accept: "By booking you accept",
        t_book_conditions: "our booking conditions",
        t_book_extra_tickets: "extra tickets",
        t_book_free_unbook: "Cancel your tickets for free until",
        t_book_no_free_unbook: "This booking cannot be cancelled without a fee.",
        t_book_read_more: "Read more.",
        t_booking_accept: "When booking you accept the",
        t_booking_amount_1: "$1$ ticket booked",
        t_booking_amount_n: "$1$ tickets booked",
        t_booking_confirmation: "You'll find your ticket on the ‘My bookings’. Cancel at least 24h before the event.",
        t_booking_instructions: "Instructions",
        t_booking_number: "Booking number:",
        t_booking_tos: "booking conditions",
        t_cancel_dialog_1: "Upon cancellation your account will be deactivated on",
        t_cancel_dialog_2: "Any bookings you might have after that date will be cancelled.",
        t_cancel_dialog_comment: "Please leave a comment reflecting why you choose to cancel your subscription. It will help us create a better product!",
        t_cancel_dialog_pause: "You can also pause for another month",
        t_cancel_dialog_unbook: "These tickets will be cancelled",
        t_card_details_why: "We need your card details to start a membership. You will not be charged.",
        t_changeplan_downgrade_1: "The change in your plan will be effective $1$",
        t_changeplan_downgrade_2: "After that date, you will pay 290 kr per month and can only book one ticket per event. One of your tickets will be cancelled for all bookings after $1$.",
        t_changeplan_downgrade_3: "You can book one extra ticket until $1$. You can also change your mind during this time.",
        t_changeplan_event_1: "To be able to book two tickets per event, you need to upgrade your account to a Plus 1 subscription.",
        t_changeplan_event_2: "To upgrade, you pay only the difference for the remaining days of the current billing period, and will pay 550kr/month from your next billing date.",
        t_changeplan_event_3: "Confirm the upgrade by paying the amount below.",
        t_changeplan_total: "Total amount to pay:",
        t_changeplan_upgrade_1: "The upgrade is effective immediately and you only pay the difference for the days remaining in the period you have already paid.",
        t_changeplan_upgrade_2: "From $1$, you will pay 550 kr per month for your new membership.",
        t_changeplan_upgrade_3: "Confirm the upgrade by paying the amount below.",
        t_choose_membership: "Book as many events as you like. All tickets and fees are included in your membership. No commitment period - cancel at any time.",
        t_decline_confirmation: "Are you sure you want to decline the reservation?",
        t_event_duration_h: "h",
        t_event_duration_m: "min",
        t_fb_connect: "Connect your Facebook account to see what your friends are going to",
        t_forgot_sent: "We have sent a password-reset link to your email address",
        t_forgot_spam: "Can't find the email? Check your spam folder.",
        t_giftcard_delivery_email: "Deliver to your email address",
        t_giftcard_delivery_post: "Sent in an envelope to the address you choose",
        t_giftcard_discount: "Includes $1$% discount",
        t_giftcard_payment: "Pay with card or Paypal and we will send the gift card.",
        t_have_reservation: "You have a reservation!",
        t_invite_choose_from: "Choose contacts from",
        t_invite_code: "Your invite code",
        t_invite_code_info: "Your friend can also enter your personal code when they register.",
        t_invite_dialog_choose: "Choose which contacts you want to invite.",
        t_invite_email: "Give a friend a free month with your unique link.",
        t_invite_or: "or",
        t_invite_popup_1: "The link above is your unique referral code which makes it easy to invite friends. Share the link anywhere - in a chat, e-mail, or text etc.",
        t_invite_popup_2: "When a friend registers through the link they get the first month for free.",
        t_invite_popup_3: "For every friend who becomes a paying member of Abundo, you will receive $1$ discount from your next payment.",
        t_invited_saved: "You've saved",
        t_membership_cancelled: "Your membership has been canceled and you can still attend events until $1$",
        t_membership_gc: "Your gift card expires $1$",
        t_membership_next_billing: "Next billing date:",
        t_membership_none: "You don't have an active membership",
        t_membership_pastdue: "We couldn't process the payment for your subscription this month. Please check that the active card is valid, open for internet purchases and that there is money in the account.",
        t_membership_paused: "Your account is paused and will resume on $1$",
        t_membership_pauses: "Your membership will be paused $1$",
        t_more_events_bottom: "Concerts, theater, opera, dance, standup, art exhibitions, film and more. New events become available every day.",
        t_more_events_count: "+ $1$ events",
        t_n_tickets: "tickets",
        t_newsletter_thanks_city: "Thank you! We'll keep you posted on what happens in",
        t_onboarding: "For the best experience, we'd like to ask you three quick questions. You can always change these later in your settings.",
        t_onboarding_category: "Click what you like so we can give you better recommendations!",
        t_onboarding_city: "Where will you mainly go to live events?",
        t_onboarding_phone_1: "We will message you when an event you booked is cancelled or changes time.",
        t_onboarding_phone_2: "You can always change your notification settings later.",
        t_past: "Selection of Abundo events during the last year",
        t_past_archived_1: "This is an archived event.",
        t_past_archived_2: "But we currently have hundreds of active",
        t_past_archived_3: "events we know you'll love!",
        t_pastdue_unbook_warning: "Warning! This booking can unbook automatically. Read more here",
        t_pause_choose_months: "Choose number of months",
        t_pause_dialog: "You keep your account and the subscription will be resumed automatically.",
        t_pause_dialog_unsubscribe: "No thanks, I want to cancel my membership",
        t_ppv_confirmation_1: "You can find your purchased content under \"My purchases\" in the menu.",
        t_ppv_confirmation_2: "A receipt has been sent to",
        t_ppv_confirmation_3: "Welcome to Abundo!",
        t_profile_favorites: "Select your favorite categories for personal tips!",
        t_profile_name: "Please contact us to change your name.",
        t_profile_show_activity: "Choose if you want your friends to see which events you go to.",
        t_promo_code: "Enter your code",
        t_rate_event: "What did you think about",
        t_referral_popup_1: "is a member in Abundo and offers you a free month when you register!",
        t_referral_popup_2: "Abundo is a subscription for hundreds of events in Stockholm and Göteborg.",
        t_referral_popup_3: "No commitment, end whenever you want",
        t_reserve_dialog: "Enter the email addresses of the friends you want to reserve tickets for. The reservation will be kept for three hours and your friend will get an email and a reservation in the \"Standby\" section in \"My bookings\".",
        t_reset_pw: "Enter a new password",
        t_resubscribe_dialog: "You card $1$ will be charged $2$ upon activation",
        t_review_see_more: "Read more",
        t_reviews: "reviews",
        t_signup_accept: "By continuing with your registration you accept our $1$ and $2$.",
        t_signup_already: "Have an account?",
        t_signup_ask_city: "Where are you located?",
        t_signup_ask_email: "What's your email?",
        t_signup_ask_name: "What's your name?",
        t_signup_confirm_email: "Confirm or update your e-mail",
        t_signup_confirm_name: "Confirm or update your name",
        t_signup_dont_activate_text: "Your account will not be charged with a membership fee. We require your credit card details for late cancellation fees only.",
        t_signup_email_already: "Your e-mail is already registered",
        t_signup_email_password: "Enter your password to log in to your existing account.",
        t_signup_enter_email_code: "Enter the 6-digit code sent to your email",
        t_signup_enter_phone: "Enter your phone number",
        t_signup_enter_phone_code: "Enter the 6-digit code sent to you",
        t_signup_gender_age: "Gender and age",
        t_signup_name_why: "For some events we add you to the guest list! Make sure your name matches the name on your ID.",
        t_signup_or: "or",
        t_signup_phone_verified: "Your phone number is verified. You can use it to log in next time.",
        t_signup_privacy: "privacy policy",
        t_signup_select_city: "Select city",
        t_signup_select_subscription: "Choose subscription",
        t_signup_subscription_explain: "Book as many events as you like. All tickets and fees are included in your membership. No commitment - cancel at any time.",
        t_signup_terms: "terms and conditions",
        t_signup_verify_phone: "Verify your phone number",
        t_ticket_activates: "Ticket activated $1$",
        t_ticket_booking: "Booking",
        t_ticket_guestlist: "Guestlist",
        t_ticket_nonrefundable: "Non refundable",
        t_ticket_people: "$1$ people",
        t_ticket_person: "$1$ person",
        t_ticket_personal: "Booking personal to $1$",
        t_ticket_row: "Row $1$",
        t_ticket_seat: "Seat $1$",
        t_video_live_members: "This content is included for Abundo subscribers",
        t_video_live_now: "Live now",
        t_video_not_active: "Activate your account to enjoy this content.",
        t_video_not_available: "This content is no longer available",
        t_video_remind_confirmation: "We'll send you a reminder by email two hours before the stream starts.",
        t_video_reminder: "You will be reminded 2 hours before the start",
        t_video_replay: "This is a replay from $1$",
        t_video_starts: "The live stream starts",
        t_video_until: "Available until $1$.",
        td_invite_accepted: "Accepted",
        td_invite_sent: "Sent",
        td_payment_failed: "Failed",
        td_payment_giftcard: "Gift card",
        td_payment_membership: "Membership",
        td_payment_purchase: "Purchase",
        td_payment_refund: "Refund",
        td_payment_tickets: "Tickets",
        td_payment_upgrade: "Upgrade",
        td_payment_valid_until: "Valid until",
        terms: "Terms of use",
        th_payment_date: "Date",
        th_payment_description: "Description",
        th_payment_method: "Payment method",
        th_payment_total: "Total",
        tt_accept_latest: "Accept latest",
        tt_book_before: "Book latest at $1$",
        w_cantbook_already: "You already have an active booking to this event.",
        w_cantbook_been: "You have already been to this event.\nWe have this restriction so that all our members can enjoy our most popular shows.",
        w_cantbook_cancel: "Your membership is no longer active on the date of the event. You can resume your membership in \"My account\"",
        w_cantbook_ended: "This event has already taken place",
        w_cantbook_expired: "This reservation is no longer available",
        w_cantbook_gc: "Your membership is no longer active on the date of the event. You can start a membership automatically when your gift card expires in \"My account\"",
        w_cantbook_limit: "You already have two active bookings. You can make a new booking when you have gone to any of the events or if you cancel one of your active bookings.",
        w_cantbook_loyalty: "This event is bookable for members who have had an active membership during the past $1$ months. You have $2$ days until you are able to book this event!",
        w_cantbook_loyalty_inactive: "This event is bookable for members who have had active memberships during the past $1$ months. Your membership is inactive paused. To book, you need to reactivate your membership and keep it active for $1$ consecutive months.",
        w_cantbook_notickets: "No tickets available.",
        w_cantbook_pastdue: "We couldn't process the payment for your subscription this month. That must be fixed before you can book",
        w_cantbook_paused: "Your account is paused. Resume your membership in \"My account\"",
        w_cantbook_sameday: "You already have a booking on this date. You can't have two active bookings on the same date.",
        w_dismiss_rating: "You can always rate past events in \"My bookings\"",
        w_late_unbook: "This is a late unbooking. You will be charged 100 kr per ticket.",
        w_membership_recovered: "Thanks! Your payment was successful and you can book again",
        w_standby: "You are now in standby.",
        w_standby_1: "You are now in standby for one ticket.",
        w_standby_2: "You are now in standby for two tickets.",
        w_standby_first: "This event is fully booked but it might be possible to get a booking. Click \"Standby\" to get a reservation when there are tickets available.",
        w_standby_info: "When more tickets are available we will randomly reserve tickets to members on the standby list",
        w_unbook: "Are you sure you want to unbook?",
        w_unbook_one: "Are you sure you want to cancel one ticket?",
    },
    ui: {
        back_to: "Back to",
        button_cancel: "CANCEL",
        button_delete: "DELETE",
        button_no: "NO",
        button_ok: "OK",
        button_save: "SAVE",
        button_send: "SEND",
        button_yes: "YES",
        img_drop: "Drop image",
        inv_email: "This is not a valid email address",
        inv_number: "The number is not within the valid interval",
        inv_password: "Password must be at least 6 characters long",
        inv_required: "This field is required",
        select_dates: "Select dates",
    },
    y: {
        currency_format: {
            EUR: "€$1$",
            SEK: "$1$ kr",
        },
        days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        short_days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        short_months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    },
};

